document.addEventListener('DOMContentLoaded', function() {

    function enforceApprovedSpecsOnly() {
      const specsSection = document.querySelector('.product-specs-section');
      if (!specsSection) return;

      const allowedLabels = new Set(['capacity', 'weight', 'made in usa', 'warranty']);
      const specItems = specsSection.querySelectorAll('.spec-item');

      specItems.forEach((item) => {
        const labelEl = item.querySelector('.spec-label');
        const label = labelEl ? labelEl.textContent.trim().toLowerCase() : '';

        if (!allowedLabels.has(label)) {
          item.remove();
        }
      });
    }

    function watchSpecsForLegacyInjection() {
      const specsSection = document.querySelector('.product-specs-section');
      if (!specsSection) return;

      const observer = new MutationObserver(() => {
        enforceApprovedSpecsOnly();
      });

      observer.observe(specsSection, {
        childList: true,
        subtree: true
      });
    }
  
    // Track page load time to prevent initial tooltips
    window.pageLoadTime = Date.now();
    
    // Function to update all selection displays
    function updateSelectionDisplays() {
      // Update size display
      const sizeDisplay = document.getElementById('selectedSizeDisplay');
      const activeSizeOption = document.querySelector('.size-option.active');
      if (sizeDisplay) {
        if (activeSizeOption) {
          sizeDisplay.textContent = activeSizeOption.dataset.size || activeSizeOption.dataset.label || 'Selected';
        } else {
          sizeDisplay.textContent = '';
        }
      }
      
      // Update color/option display
      const colorDisplay = document.getElementById('selectedColorDisplay');
      const colorSelectionDisplay = document.getElementById('colorSelectionDisplay');
      const activeColorOption = document.querySelector('.color-circle.active, .option-circle.active');
      if (colorDisplay && colorSelectionDisplay) {
        const optionType = colorSelectionDisplay.dataset.optionType || 'Color';
        const labelElement = colorSelectionDisplay.querySelector('.selection-label');
        if (labelElement) {
          labelElement.textContent = `Selected ${optionType}`;
        }
        if (activeColorOption) {
          colorDisplay.textContent = activeColorOption.dataset.color || activeColorOption.dataset.label || 'Selected';
        } else {
          colorDisplay.textContent = '';
        }
      }
      
      // Update lock display
      const lockDisplay = document.getElementById('selectedLockDisplay');
      const activeLockOption = document.querySelector('.lock-option.active');
      if (lockDisplay) {
        if (activeLockOption) {
          lockDisplay.textContent = activeLockOption.dataset.lock || activeLockOption.dataset.label || 'Selected';
        } else {
          lockDisplay.textContent = '';
        }
      }
      
      // Update upgrade display(s) — handle dynamic IDs
      document.querySelectorAll('[id^="upgradeSelectionDisplay-"]').forEach(function(displayContainer) {
        const pos = displayContainer.id.replace('upgradeSelectionDisplay-', '');
        const valueEl = document.getElementById('selectedUpgradeDisplay-' + pos);
        const activeOption = document.querySelector('#upgradeOptions-' + pos + ' .upgrade-option.active');
        if (valueEl) {
          if (activeOption) {
            valueEl.textContent = activeOption.dataset.displayText || activeOption.dataset.upgrade || 'Selected';
          } else {
            valueEl.textContent = '';
          }
        }
      });
      
      // Update lock upgrade display
      const lockUpgradeDisplay = document.getElementById('selectedLockUpgradeDisplay');
      const activeLockUpgradeOption = document.querySelector('#lockUpgradeOptions .upgrade-option.active');
      if (lockUpgradeDisplay) {
        if (activeLockUpgradeOption) {
          const displayText = activeLockUpgradeOption.dataset.displayText || activeLockUpgradeOption.dataset.upgrade || 'Selected';
          lockUpgradeDisplay.textContent = displayText;
        } else {
          lockUpgradeDisplay.textContent = '';
        }
      }
    }
    
    // Function to filter upgrade options (Swing Out Gun Rack, etc.) based on selected size.
    // NOTE: this used to target `.option-circle` / `data-color` with a "(Size 6030)" /
    // "(Sizes: 6636-7241-7253)" text convention baked into the option value. The liquid
    // template (safe-builder.liquid, opt_type == 'upgrade') renders these as `.upgrade-option`
    // elements with a `data-upgrade` attribute instead, and real option value text like
    // "Add Swing Out Gun Rack System +($299 for the 6033 size or $389 for other sizes)"
    // never matched that bracket pattern anyway — so this was a no-op on every current
    // product. Rewritten to check the real variant list for a (size, upgrade) match instead
    // of parsing English text, and to target the class the template actually renders.
    function filterSwingOutOptions() {
      const selectedSize = window.selectedSize;
      const upgradeOptionEls = document.querySelectorAll('.upgrade-option');
      if (!upgradeOptionEls.length) return;

      const productJsonElement = document.getElementById('product-json');
      let localProductData = null;
      if (productJsonElement) {
        try {
          localProductData = JSON.parse(productJsonElement.textContent);
        } catch (e) {
          return;
        }
      }

      if (!selectedSize || !localProductData || !localProductData.variants) {
        upgradeOptionEls.forEach(el => { el.style.display = ''; });
        return;
      }

      // Group by the option position (Lock upgrade vs. Swing Out Gun Rack, etc. can each
      // have their own picker) so "deselect and fall back to the first visible one" only
      // considers options within the same picker, not across all upgrade pickers on the page.
      const groups = {};
      upgradeOptionEls.forEach(el => {
        const pos = el.dataset.optionPosition || 'default';
        if (!groups[pos]) groups[pos] = [];
        groups[pos].push(el);
      });

      Object.values(groups).forEach(group => {
        let currentlySelectedOption = null;
        let shouldDeselectCurrent = false;
        let firstVisibleOption = null;

        group.forEach(el => {
          const upgradeValue = el.dataset.upgrade || '';
          const isAvailable = localProductData.variants.some(variant => {
            const opts = [variant.option1, variant.option2, variant.option3];
            return opts.includes(selectedSize) && opts.includes(upgradeValue);
          });

          el.style.display = isAvailable ? '' : 'none';

          if (el.classList.contains('active')) {
            currentlySelectedOption = el;
            if (!isAvailable) shouldDeselectCurrent = true;
          }
          if (isAvailable && !firstVisibleOption) {
            firstVisibleOption = el;
          }
        });

        if (shouldDeselectCurrent && currentlySelectedOption) {
          currentlySelectedOption.classList.remove('active');

          if (firstVisibleOption) {
            firstVisibleOption.classList.add('active');
            if (window.updateSelectionDisplays) window.updateSelectionDisplays();
            if (window.updateSelectedVariant) window.updateSelectedVariant();
          }
        }
      });
    }

    // Hide color/finish swatches that don't exist as a real variant for the
    // selected size (e.g. Textured White only exists on TF5517, not TF5924),
    // instead of leaving every swatch clickable regardless of size.
    function filterColorOptionsBySize() {
      const selectedSize = window.selectedSize;
      const colorCircleEls = document.querySelectorAll('.color-circle');
      if (!colorCircleEls.length) return;

      const productJsonElement = document.getElementById('product-json');
      let localProductData = null;
      if (productJsonElement) {
        try {
          localProductData = JSON.parse(productJsonElement.textContent);
        } catch (e) {
          return;
        }
      }

      if (!selectedSize || !localProductData || !localProductData.variants) {
        colorCircleEls.forEach(circle => { circle.style.display = ''; });
        return;
      }

      let currentlySelectedCircle = null;
      let shouldDeselectCurrent = false;
      let firstVisibleCircle = null;

      colorCircleEls.forEach(circle => {
        const colorValue = circle.dataset.color || '';
        const isAvailable = localProductData.variants.some(variant => {
          const opts = [variant.option1, variant.option2, variant.option3];
          return opts.includes(selectedSize) && opts.includes(colorValue);
        });

        circle.style.display = isAvailable ? '' : 'none';

        if (circle.classList.contains('active')) {
          currentlySelectedCircle = circle;
          if (!isAvailable) shouldDeselectCurrent = true;
        }
        if (isAvailable && !firstVisibleCircle) {
          firstVisibleCircle = circle;
        }
      });

      if (shouldDeselectCurrent && currentlySelectedCircle) {
        currentlySelectedCircle.classList.remove('active');
        if (firstVisibleCircle) {
          firstVisibleCircle.classList.add('active');
          window.selectedColor = firstVisibleCircle.dataset.color;
          if (window.updateSelectionDisplays) window.updateSelectionDisplays();
          if (window.updateSelectedVariant) window.updateSelectedVariant();
        } else {
          window.selectedColor = null;
        }
      }
    }

    // Make the functions globally accessible
    window.updateSelectionDisplays = updateSelectionDisplays;
    window.filterSwingOutOptions = filterSwingOutOptions;
    window.filterColorOptionsBySize = filterColorOptionsBySize;
    
    // Initialize tooltips
    initTooltips();
    
    // Initialize sticky cart
    initStickyCart();

    // Keep product specs locked to the approved subset only.
    enforceApprovedSpecsOnly();
    watchSpecsForLegacyInjection();
    
    // Wait for the gallery system to initialize before setting up custom variant selection
    setTimeout(initializeCustomVariantSelection, 500);
  });
  
  // Global mobile device detection function
  function isMobileDevice() {
    // Only disable tooltips on actual touch devices
    // Don't use screen width as a factor - desktop users on smaller screens still have mouse hover
    const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    
    // Only consider it mobile if it has touch AND matches mobile user agent
    // This way, desktop users on small screens still get tooltips
    const isMobile = hasTouch && isMobileUA;
    
    return isMobile;
  }
  
  function initTooltips() {
    // Check if we're on a mobile device using more accurate detection
    
    if (isMobileDevice()) {
      return;
    }
    
    // Remove global tooltip if it exists (we'll use individual tooltips)
    const globalTooltip = document.getElementById("tooltip");
    if (globalTooltip) {
      globalTooltip.remove();
    }
    
    const tooltipElements = document.querySelectorAll("[data-tooltip]");

    tooltipElements.forEach((element) => {
      // Instead of creating tooltip inside the element, create it in the document body
      // and position it absolutely relative to the viewport
      let tooltip = document.getElementById(`tooltip-${element.className.replace(/\s+/g, '-')}-${Math.random().toString(36).substr(2, 9)}`);
      if (!tooltip) {
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip';
        tooltip.id = `tooltip-${element.className.replace(/\s+/g, '-')}-${Math.random().toString(36).substr(2, 9)}`;
        // Append to body instead of inside the element
        document.body.appendChild(tooltip);
      }
  
      // Clear any existing event listeners
      element.onmouseenter = null;
      element.onmouseleave = null;
  
      // Use direct event handler assignment for maximum compatibility
      element.onmouseenter = function(e) {
        // Don't show tooltip immediately on page load - add a small delay to prevent initial tooltips
        if (Date.now() - window.pageLoadTime < 3000) {
          return;
        }
        
        
        const tooltipText = this.getAttribute('data-tooltip');
        if (!tooltipText) {
          return;
        }
        
        tooltip.textContent = tooltipText;
        tooltip.classList.add("visible");
        
        // Position tooltip relative to the viewport, above the element
        const rect = this.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        
        // Position above the element
        const left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
        const top = rect.top - tooltipRect.height - 10;
        
        // Make sure tooltip doesn't go outside viewport
        const finalLeft = Math.max(10, Math.min(left, window.innerWidth - tooltipRect.width - 10));
        const finalTop = Math.max(10, top);
        
        tooltip.style.position = 'fixed';
        tooltip.style.left = finalLeft + 'px';
        tooltip.style.top = finalTop + 'px';
        tooltip.style.zIndex = '99999';
  
      };
  
      element.onmouseleave = function(e) {
        tooltip.classList.remove("visible");
      };
  
      // Special handling for problematic elements
      if (element.classList.contains('color-circle') || element.classList.contains('lock-option')) {
        
        // Force pointer events
        element.style.pointerEvents = 'auto';
        element.style.position = 'relative';
        element.style.zIndex = '10';
        
        // For gloss circles, ensure tooltip is really high
        if (element.getAttribute('data-color') && 
            element.getAttribute('data-color').toLowerCase().includes('gloss')) {
          tooltip.style.zIndex = '100000';
        }
      }
    });
  
    }

  function initStickyCart() {
    const stickyCart = document.getElementById("sticky-cart");
    const mainAddToCart = document.getElementById("addToCartBtn"); // Use the actual button ID
    const jumpToTopBtn = document.getElementById("jump-to-top");
    const productSection = document.querySelector(".product_section");

    if (!stickyCart || !mainAddToCart) {
      return;
    }

    // This runs twice on a normal page load in the theme editor (once from the
    // main init flow, once from safeBuilderInit() on shopify:section:load,
    // which the editor also fires on first load, not just on reorder) — without
    // this guard every listener below gets bound twice, so the mobile collapse
    // toggle's classList.toggle('expanded') flips on then back off in the same
    // click (looks like a dead button), and worse, the sticky Add to Cart
    // button would fire the real add-to-cart click twice per tap.
    if (stickyCart.dataset.stickyCartInitialized === 'true') {
      return;
    }
    stickyCart.dataset.stickyCartInitialized = 'true';

    // Check if main button is visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyCart.classList.remove("visible");
          } else {
            stickyCart.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );
  
    observer.observe(mainAddToCart);
  
    // Check if user has scrolled past the product section for jump to top button.
    // jump-to-top's visibility depends on TWO independent signals — scroll
    // position (this observer) AND whether the mobile card is collapsed (the
    // toggle below) — funneled through one function so there's a single place
    // setting its inline style. Setting it in two places directly caused a real
    // bug: this observer's inline style always wins over the CSS collapsed-state
    // display:none rule (inline beats any class-based rule regardless of
    // specificity), so once scrolled far enough the button stayed visible even
    // while "collapsed" — sitting in a grid area ("top") that the collapsed
    // 1-row layout doesn't have, which is what scrambled the price/image/button
    // positions.
    let pastProductSection = false;
    function updateJumpToTopVisibility() {
      if (!jumpToTopBtn) return;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const collapsedOnMobile = isMobile && !stickyCart.classList.contains('expanded');
      jumpToTopBtn.style.display = (pastProductSection && !collapsedOnMobile) ? 'flex' : 'none';
    }

    const jumpToTopObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          pastProductSection = !entry.isIntersecting;
          updateJumpToTopVisibility();
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px 50px 0px" // Show button slightly before completely leaving section
      }
    );

    if (productSection && jumpToTopBtn) {
      jumpToTopObserver.observe(productSection);
    }

    window.addEventListener('resize', updateJumpToTopVisibility, { passive: true });
  
    // Add click handler for sticky cart button
    const stickyButton = document.getElementById("sticky-add-to-cart");
    if (stickyButton) {
      stickyButton.addEventListener('click', function() {
        // Trigger the main add to cart button
        mainAddToCart.click();
      });
    }
  
    // Add click handler for jump to top button
    if (jumpToTopBtn) {
      jumpToTopBtn.addEventListener('click', function() {
        // Scroll to the main add to cart button smoothly
        mainAddToCart.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      });
    }

    // Mobile collapse/expand handle — desktop's floating pill is small
    // enough already and hides this button entirely via CSS, so this is a
    // no-op there regardless of state.
    const stickyCartToggle = document.getElementById("sticky-cart-toggle");
    if (stickyCartToggle) {
      stickyCartToggle.addEventListener('click', function () {
        const expanded = stickyCart.classList.toggle('expanded');
        stickyCartToggle.setAttribute('aria-expanded', String(expanded));
        stickyCartToggle.setAttribute('aria-label', expanded ? 'Hide product details' : 'Show product details');
        updateJumpToTopVisibility();
      });
    }
  }
  
  function initializeCustomVariantSelection() {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  
    // Initialize mobile carousel for key features with a slight delay to ensure DOM is ready
    setTimeout(() => {
      initializeKeyFeaturesCarousel();
    }, 100);
  
    // Get product data
    const productJsonElement = document.getElementById('product-json');
    let productData = null;
    
    if (productJsonElement) {
      try {
        productData = JSON.parse(productJsonElement.textContent);
      } catch (e) {
      }
    }
  
    if (!productData) {
      return;
    }

    let variantImagesData = null;
    const variantImagesElement = document.getElementById(`variant-images-${productData.id}`);
    if (variantImagesElement) {
      try {
        variantImagesData = JSON.parse(variantImagesElement.textContent);
      } catch (e) {
      }
    }

    // ============================================
    // DYNAMIC OPTION ANALYZER
    // Determines what each option position contains
    // ============================================
    function buildOptionMap() {
      // First try to load pre-built map from Liquid
      const productId = productData.id;
      const liquidMapElement = document.getElementById(`product-option-map-${productId}`);
      
      if (liquidMapElement) {
        try {
          const liquidData = JSON.parse(liquidMapElement.textContent);
          const optionMap = {};

          liquidData.options.forEach(opt => {
            // Use type from Liquid JSON if available (most reliable)
            let type = opt.type || 'unknown';

            // Map Liquid type names to JS internal names
            if (type === 'generic') type = 'other';
            if (type === 'unknown') {
              // Fallback: classify based on name keywords
              const optionName = opt.name_lower;
              if (optionName.includes('size') || optionName.includes('dimension')) {
                type = 'size';
              } else if (optionName.includes('color') || optionName.includes('finish')) {
                type = 'color';
              } else if (optionName.includes('lock')) {
                type = 'lock';
              } else if (optionName.includes('upgrade') || optionName.includes('gun rack') || optionName.includes('system') || optionName.includes('door panel')) {
                type = 'upgrade';
              } else {
                type = 'other';
              }
            }

            optionMap[opt.position] = {
              name: opt.name,
              type: type,
              index: opt.position - 1,
              matchedKeywords: [type]
            };
          });

          return optionMap;
        } catch (e) {
        }
      }
      
      // Fallback: build map from product data
      const optionMap = {};
      
      if (!productData.options || productData.options.length === 0) {
        return optionMap;
      }
      
      // Build map: { optionIndex: { name, type, keywordMatches } }
      productData.options.forEach((option, index) => {
        const optionName = option.name.toLowerCase();
        const optionPosition = index + 1; // 1-based indexing for variant.optionX
        
        let type = 'unknown';
        let matchedKeywords = [];
        
        // Detect option type by name keywords
        if (optionName.includes('size') || optionName.includes('dimension')) {
          type = 'size';
          matchedKeywords.push('size');
        } else if (optionName.includes('color') || optionName.includes('finish')) {
          type = 'color';
          matchedKeywords.push('color');
        } else if (optionName.includes('lock')) {
          type = 'lock';
          matchedKeywords.push('lock');
        } else if (optionName.includes('upgrade') || optionName.includes('upgrade') || 
                   optionName.includes('gun rack') || optionName.includes('system')) {
          type = 'upgrade';
          matchedKeywords.push('upgrade');
        } else {
          // Fallback: analyze actual values to determine type
          const analyzedType = analyzeOptionValueType(index);
          // Only accept analyzed type if it's not 'other' (avoid false positives)
          type = (analyzedType !== 'other') ? analyzedType : 'other';
        }
        
        optionMap[optionPosition] = {
          name: option.name,
          type: type,
          index: index,
          matchedKeywords: matchedKeywords
        };
      });
      
      return optionMap;
    }
    
    // Helper: Analyze option values to determine type
    function analyzeOptionValueType(optionIndex) {
      const values = productData.variants
        .map(v => v[`option${optionIndex + 1}`])
        .filter(v => v && v !== 'Default Title' && v !== 'No Upgrade')
        .slice(0, 5); // Sample first 5 values
      
      if (values.length === 0) return 'unknown';
      
      const valueString = values.join(' ').toLowerCase();
      
      // Color keywords
      if (/marble|textured|gloss|red|blue|green|yellow|brown|black|white|gray|grey|silver|gold|bronze|burgundy|finish/.test(valueString)) {
        return 'color';
      }
      
      // Lock keywords
      if (/electronic|mechanical|dial|lock|biometric|keypad/.test(valueString)) {
        return 'lock';
      }
      
      // Upgrade keywords (prices, add-ons)
      if (/\badd\b|upgrade|system|\+\$|\(\$/.test(valueString)) {
        return 'upgrade';
      }
      
      return 'other';
    }
    
    // Build the option map
    const productOptionMap = buildOptionMap();
    
    window.productOptionMap = productOptionMap;
  
  // Mobile carousel functionality for key features
  function initializeKeyFeaturesCarousel() {
    const keyFeaturesContainer = document.querySelector('.key-features');
    const keyFeaturesWrapper = document.querySelector('.key-features-wrapper');
    
    // Check if elements exist and if we're on mobile
    if (!keyFeaturesContainer || !keyFeaturesWrapper) {
      return;
    }
    
    // Function to check if we're on mobile
    function isMobile() {
      return window.innerWidth <= 767;
    }
    
    if (!isMobile()) {
      return; // Only initialize on mobile
    }
  
    // Remove any existing indicators first
    const existingIndicators = keyFeaturesWrapper.querySelector('.carousel-indicators');
    if (existingIndicators) {
      existingIndicators.remove();
    }
  
    const features = keyFeaturesContainer.querySelectorAll('.feature-item');
    const totalFeatures = features.length;
    
    if (totalFeatures <= 2) {
      return; // No need for carousel if 2 or fewer features
    }
  
    // Calculate number of pages (showing 2 features per page)
    const totalPages = Math.ceil(totalFeatures / 2);
    let currentPage = 0;
    let autoplayInterval;
    
    // Only create indicators if we have more than 1 page
    if (totalPages > 1) {
      // Create carousel indicators
      const indicatorsContainer = document.createElement('div');
      indicatorsContainer.className = 'carousel-indicators';
      
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('div');
        dot.className = `carousel-dot ${i === 0 ? 'active' : ''}`;
        dot.addEventListener('click', () => {
          stopAutoplay();
          scrollToPage(i);
          startAutoplay();
        });
        indicatorsContainer.appendChild(dot);
      }
      
      keyFeaturesWrapper.appendChild(indicatorsContainer);
    }
  
    // Scroll to specific page
    function scrollToPage(pageIndex) {
      currentPage = pageIndex;
      
      // Get container width and calculate scroll position more accurately
      const containerWidth = keyFeaturesContainer.offsetWidth;
      const gap = 15; // Gap between items as defined in CSS
      
      // Each feature is 50% width minus half the gap
      const featureWidth = (containerWidth - gap) / 2;
      
      // Each page scrolls by the width of 2 features plus the gap between them
      const scrollPosition = pageIndex * containerWidth;
      
      keyFeaturesContainer.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
      
      // Update active indicator
      updateActiveIndicator(pageIndex);
    }
  
    // Update active indicator
    function updateActiveIndicator(pageIndex) {
      const indicatorsContainer = document.querySelector('.carousel-indicators');
      if (indicatorsContainer) {
        const dots = indicatorsContainer.querySelectorAll('.carousel-dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === pageIndex);
        });
      }
    }
  
    // Start autoplay
    function startAutoplay() {
      stopAutoplay(); // Clear any existing interval
      autoplayInterval = setInterval(() => {
        const nextPage = (currentPage + 1) % totalPages;
        scrollToPage(nextPage);
      }, 6000); // 6 seconds
    }
  
    // Stop autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
  
    // Handle scroll events to update indicators
    let scrollTimeout;
    keyFeaturesContainer.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const containerWidth = keyFeaturesContainer.offsetWidth;
        const scrollLeft = keyFeaturesContainer.scrollLeft;
        
        // Calculate which page we're on
        const calculatedPage = Math.round(scrollLeft / containerWidth);
        const newPage = Math.max(0, Math.min(calculatedPage, totalPages - 1));
        
        if (newPage !== currentPage) {
          currentPage = newPage;
          updateActiveIndicator(currentPage);
        }
        
      }, 100);
    });
  
    // Handle touch/swipe gestures
    let startX = 0;
    let scrollStart = 0;
    let isDragging = false;
  
    keyFeaturesContainer.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      scrollStart = keyFeaturesContainer.scrollLeft;
      isDragging = false;
      stopAutoplay(); // Stop autoplay when user interacts
    });
  
    keyFeaturesContainer.addEventListener('touchmove', function(e) {
      if (!startX) return;
      
      isDragging = true;
      const currentX = e.touches[0].clientX;
      const diffX = startX - currentX;
      keyFeaturesContainer.scrollLeft = scrollStart + diffX;
    });
  
    keyFeaturesContainer.addEventListener('touchend', function() {
      if (!startX || !isDragging) {
        startAutoplay(); // Resume autoplay
        return;
      }
      
      // Calculate which page we should snap to
      const containerWidth = keyFeaturesContainer.offsetWidth;
      const scrollLeft = keyFeaturesContainer.scrollLeft;
      const nearestPage = Math.round(scrollLeft / containerWidth);
      
      
      scrollToPage(Math.max(0, Math.min(nearestPage, totalPages - 1)));
      
      startX = 0;
      scrollStart = 0;
      isDragging = false;
      
      // Resume autoplay after interaction
      setTimeout(() => {
        startAutoplay();
      }, 1000);
    });
  
    // Pause autoplay on hover/focus
    keyFeaturesContainer.addEventListener('mouseenter', stopAutoplay);
    keyFeaturesContainer.addEventListener('mouseleave', startAutoplay);
  
    // Initialize to show first page (features 1 and 2)
    function initializeCarousel() {
      // Ensure we start at the beginning
      keyFeaturesContainer.scrollLeft = 0;
      currentPage = 0;
      updateActiveIndicator(0);
      
      
      // Start autoplay after a short delay
      setTimeout(() => {
        if (totalPages > 1) {
          startAutoplay();
        }
      }, 1000);
    }
    
    // Use a more reliable initialization approach
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCarousel);
    } else {
      // DOM is already ready
      setTimeout(initializeCarousel, 100);
    }
  
    // Handle visibility change to pause/resume autoplay
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });
    
    // Handle window resize to reinitialize if needed
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // If we switched from desktop to mobile or vice versa, reinitialize
        const shouldHaveCarousel = isMobile() && totalFeatures > 2;
        const hasCarousel = keyFeaturesWrapper.querySelector('.carousel-indicators') !== null;
        
        if (shouldHaveCarousel && !hasCarousel) {
          initializeKeyFeaturesCarousel();
        } else if (!shouldHaveCarousel && hasCarousel) {
          // Need to remove carousel
          const indicators = keyFeaturesWrapper.querySelector('.carousel-indicators');
          if (indicators) indicators.remove();
          stopAutoplay();
        }
      }, 300);
    });
  }
  
    // Get DOM elements
    const sizeOptions = document.querySelectorAll('.size-option');
    const colorCircles = document.querySelectorAll('.color-circle');
    const lockOptions = document.querySelectorAll('.lock-option');
    const addToCartBtn = document.getElementById('addToCartBtn');
    const mainAddToCartBtn = document.getElementById('main-add-to-cart') || addToCartBtn;
    const variantIdInput = document.getElementById('variantId');
    const productPrice = document.getElementById('productPrice');
    const deliverySelect = document.getElementById('deliverySelect');
    
    // Get main product image elements - Updated selectors for your gallery
    const mainGallery = document.querySelector('.product-gallery__main');
    const mainProductImage = document.querySelector('.product-gallery__main img, .product__images img, .featured-product__images img');
    const thumbnailImages = document.querySelectorAll('.thumbnail-slider__nav img, .product-gallery__thumbnails img');
  
    // Selected options
    let selectedSize = null;
    let selectedColor = null;
    let selectedLock = null;
    let selectedUpgrade = null;
    let selectedOther = {}; // { optionPosition: selectedValue } for generic options
    let selectedDelivery = 0; // No delivery cost (commented out in product builder)
    let selectedUpgrades = []; // Track multiple upgrades for stacking prices
  
    // Calculate total price including upgrades (no delivery cost)
    // Variant price is the source of truth, but we can extract upgrade costs for display
    function calculateTotalPrice(variant) {
      // The variant price from Shopify is the definitive price
      // It already includes all selected options combinations
      if (variant && variant.price) {
        return variant.price;
      }
      
      // Fallback to product base price if no variant found
      return productData ? productData.price : 0;
    }
    
    // Helper: Extract upgrade costs from option text for transparency/display
    // This doesn't affect total price (variant price is source of truth)
    // but helps show customers which options add cost
    function extractUpgradeCostsFromSelections() {
      const upgradeCosts = [];
      
      // Check each selected upgrade option for embedded costs
      if (selectedUpgrade && selectedUpgrade !== 'None' && selectedUpgrade !== 'No Upgrade') {
        const upgradeCost = extractPriceFromText(selectedUpgrade);
        if (upgradeCost > 0) {
          upgradeCosts.push({
            name: selectedUpgrade,
            cost: upgradeCost
          });
        }
      }
      
      // Check lock cost
      if (selectedLock && selectedLock !== 'None') {
        const lockCost = extractPriceFromText(selectedLock);
        if (lockCost > 0) {
          upgradeCosts.push({
            name: selectedLock,
            cost: lockCost
          });
        }
      }
      
      // Check color cost if applicable
      if (selectedColor && selectedColor !== 'None') {
        const colorCost = extractPriceFromText(selectedColor);
        if (colorCost > 0) {
          upgradeCosts.push({
            name: selectedColor,
            cost: colorCost
          });
        }
      }
      
      return upgradeCosts;
    }
  
    // Helper function to find variant matching current selections
    // Uses dynamic option map to handle products with varying option structures
    function findMatchingVariant() {
      if (!productData || !productData.variants) return null;

      const matchedVariant = productData.variants.find(variant => {
        let allMatch = true;
        
        // For each option position in the product, check if it matches our selection
        for (const [optionPos, optionInfo] of Object.entries(productOptionMap)) {
          const optionIndex = parseInt(optionPos);
          const variantValue = variant[`option${optionIndex}`];
          
          if (!variantValue || variantValue === 'Default Title') continue;
          
          // Determine what selection to match against based on option type
          let selectedValue = null;
          let matched = false;

          // safe-builder.liquid always renders option position 1 through the
          // "Size Selection" UI (data-size / selectedSize) no matter what that
          // option is actually named — e.g. Blockade's "Choose Door Swing" isn't
          // size-named, gets keyword-classified as 'other', but is still clicked
          // as a .size-option. Force position 1 to match as 'size' so the click
          // isn't silently ignored here.
          const effectiveType = (optionIndex === 1) ? 'size' : optionInfo.type;

          switch(effectiveType) {
            case 'size':
              selectedValue = selectedSize;
              // If no size selected yet, any size is fine
              matched = !selectedValue || variantValue === selectedValue;
              break;
              
            case 'color':
              selectedValue = selectedColor;
              // If no color selected yet, any color is fine
              matched = !selectedValue || variantValue === selectedValue;
              break;
              
            case 'lock':
              selectedValue = selectedLock;
              // If no lock selected yet, any lock is fine
              matched = !selectedValue || variantValue === selectedValue;
              break;
              
            case 'upgrade':
              selectedValue = selectedUpgrade;
              if (selectedValue) {
                // User has selected an upgrade - match exactly or by substring
                matched = variantValue === selectedValue || 
                          variantValue.includes(selectedValue) ||
                          selectedValue.includes(variantValue);
              } else {
                // No upgrade selected - match variants with "Do Not", "No", or non-upgrade options
                const variantLower = variantValue.toLowerCase();
                matched = variantLower.includes('do not') || 
                          variantLower.includes('no ') ||
                          variantLower === 'default' ||
                          (!variantLower.includes('add') && !variantLower.includes('upgrade to'));
              }
              break;
              
            case 'other':
              // Use generic option selection only — do NOT fall back to color/upgrade
              selectedValue = (selectedOther && selectedOther[String(optionIndex)]) || null;
              if (selectedValue) {
                matched = variantValue === selectedValue ||
                          variantValue.includes(selectedValue);
              } else {
                // No selection made for this type - accept any value
                matched = true;
              }
              break;
              
            default:
              // Unknown type - accept any value
              matched = true;
          }
          
          if (!matched) {
            allMatch = false;
            break;
          }
        }
        
        return allMatch;
      });
      
      return matchedVariant || null;
    }
  
    // Helper function to extract upgrade cost from variant pricing
    function extractUpgradeCost(upgradeText) {
      if (!upgradeText) return 0;
      
      // First try to get price from variant difference
      const currentVariant = findMatchingVariant();
      if (currentVariant && productData && productData.variants) {
        // Find a base variant with the same size but no upgrades
        const baseVariant = productData.variants.find(variant => {
          const sizeMatch = variant.option1 === selectedSize;
          const colorMatch = (!selectedColor) || (variant.option2 === selectedColor || variant.option3 === selectedColor);
          
          // Look for base variant (no upgrade options)
          const isBaseUpgrade = (
            (variant.option2 && (variant.option2.includes('No Upgrade') || variant.option2 === 'None')) ||
            (variant.option3 && (variant.option3.includes('No Upgrade') || variant.option3 === 'None')) ||
            (!variant.option2.includes('LED') && !variant.option2.includes('LIGHT') && !variant.option2.includes('PACKAGE')) ||
            (!variant.option3.includes('LED') && !variant.option3.includes('LIGHT') && !variant.option3.includes('PACKAGE'))
          );
          
          return sizeMatch && colorMatch && isBaseUpgrade;
        });
        
        if (baseVariant && currentVariant.price > baseVariant.price) {
          return currentVariant.price - baseVariant.price;
        }
        
        // Alternative approach: look for variants with the exact upgrade text
        const upgradeVariants = productData.variants.filter(variant => {
          const hasUpgradeInOption2 = variant.option2 && variant.option2.includes('LED LIGHT PACKAGE');
          const hasUpgradeInOption3 = variant.option3 && variant.option3.includes('LED LIGHT PACKAGE');
          const sizeMatch = variant.option1 === selectedSize;
          
          return sizeMatch && (hasUpgradeInOption2 || hasUpgradeInOption3);
        });
        
        if (upgradeVariants.length > 0) {
          
          // Find the cheapest base variant for this size to calculate difference
          const baseVariants = productData.variants.filter(variant => {
            const sizeMatch = variant.option1 === selectedSize;
            const noUpgrade = (!variant.option2 || !variant.option2.includes('LED')) && 
                             (!variant.option3 || !variant.option3.includes('LED'));
            return sizeMatch && noUpgrade;
          });
          
          if (baseVariants.length > 0) {
            const cheapestBase = baseVariants.reduce((prev, curr) => prev.price < curr.price ? prev : curr);
            const cheapestUpgrade = upgradeVariants.reduce((prev, curr) => prev.price < curr.price ? prev : curr);
            const priceDifference = cheapestUpgrade.price - cheapestBase.price;
            
            return priceDifference;
          }
        }
      }
      
      // Fallback to text parsing if variant pricing doesn't work
      return extractPriceFromText(upgradeText);
    }
  
    // Helper function to extract price from option text (for locks, etc.)
    function extractPriceFromOption(optionText) {
      if (!optionText) return 0;
      
      // First try to get price from variant difference
      const currentVariant = findMatchingVariant();
      if (currentVariant && productData && productData.variants) {
        
        // Find a base variant with the same size/upgrade but different lock
        const baseVariant = productData.variants.find(variant => {
          const sizeMatch = variant.option1 === selectedSize;
          const upgradeMatch = (!selectedUpgrade || selectedUpgrade === 'none') || 
                              (variant.option2 === selectedUpgrade || variant.option3 === selectedUpgrade) ||
                              (variant.option2 && variant.option2.includes('LED LIGHT PACKAGE') && selectedUpgrade && selectedUpgrade.includes('LED LIGHT PACKAGE'));
          
          // Find base lock (usually Electronic, Standard, Basic, or Mechanical without additional cost)
          const isBaseLock = (
            (variant.option2 && (variant.option2.includes('Electronic') || variant.option2 === 'Standard' || variant.option2 === 'Basic')) ||
            (variant.option3 && (variant.option3.includes('Electronic') || variant.option3 === 'Standard' || variant.option3 === 'Basic')) ||
            (!variant.option2.includes('Mechanical Dial') && !variant.option3.includes('Mechanical Dial'))
          );
          
          return sizeMatch && upgradeMatch && isBaseLock;
        });
        
        if (baseVariant && currentVariant.price > baseVariant.price) {
          return currentVariant.price - baseVariant.price;
        }
        
        // Alternative approach: find variants with Electronic vs Mechanical Dial for same size/upgrade
        const electronicVariants = productData.variants.filter(variant => {
          const sizeMatch = variant.option1 === selectedSize;
          const hasElectronic = (variant.option2 && variant.option2.includes('Electronic')) || 
                               (variant.option3 && variant.option3.includes('Electronic'));
          const upgradeMatch = (!selectedUpgrade) || 
                              (variant.option2 && selectedUpgrade && variant.option2.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE')) ||
                              (variant.option3 && selectedUpgrade && variant.option3.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE'));
          
          return sizeMatch && hasElectronic && upgradeMatch;
        });
        
        const mechanicalVariants = productData.variants.filter(variant => {
          const sizeMatch = variant.option1 === selectedSize;
          const hasMechanical = (variant.option2 && variant.option2.includes('Mechanical Dial')) || 
                               (variant.option3 && variant.option3.includes('Mechanical Dial'));
          const upgradeMatch = (!selectedUpgrade) || 
                              (variant.option2 && selectedUpgrade && variant.option2.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE')) ||
                              (variant.option3 && selectedUpgrade && variant.option3.includes('LED LIGHT PACKAGE') && selectedUpgrade.includes('LED LIGHT PACKAGE'));
          
          return sizeMatch && hasMechanical && upgradeMatch;
        });
        
        if (electronicVariants.length > 0 && mechanicalVariants.length > 0 && optionText.includes('Mechanical')) {
          const electronicPrice = electronicVariants[0].price;
          const mechanicalPrice = mechanicalVariants[0].price;
          const priceDifference = mechanicalPrice - electronicPrice;
          
          return priceDifference;
        }
      }
      
      // Fallback to text parsing
      return extractPriceFromText(optionText);
    }
  
    // Helper function to extract price from text (fallback method)
    function extractPriceFromText(text) {
      if (!text) return 0;
      
      // Try to extract price from text
      // Look for patterns like "+$123", "$123", "(+$123)", "Price: $123", etc.
      const textStr = text.toString();
      
      // Multiple price patterns to try
      const patterns = [
        /\+\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,        // +$123 or + $123
        /\(\+\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)\)/i,    // (+$123) or (+ $123)
        /price:\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,    // Price: $123
        /cost:\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,     // Cost: $123
        /\$(\d+(?:,\d{3})*(?:\.\d{2})?)\s*(?:extra|additional|more)/i, // $123 extra
        /add\s*\$(\d+(?:,\d{3})*(?:\.\d{2})?)/i,       // add $123
        /\$(\d+(?:,\d{3})*(?:\.\d{2})?)/                // Last resort: any $123
      ];
      
      for (const pattern of patterns) {
        const priceMatch = textStr.match(pattern);
        if (priceMatch) {
          // Remove commas and convert to cents
          const priceStr = priceMatch[1].replace(/,/g, '');
          const cost = Math.round(parseFloat(priceStr) * 100);
          return cost;
        }
      }

      return 0;
    }
  
    // Format money with commas
    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      const parts = dollars.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function getStickyVariantTitle(variant) {
      if (variant && variant.title && variant.title !== 'Default Title') {
        return variant.title;
      }

      if (selectedSize) {
        return selectedSize;
      }

      return 'Choose your configuration';
    }

    function getStickyVariantImageUrl(variant) {
      if (variantImagesData && variant && variantImagesData.variants && variantImagesData.variants[variant.id]) {
        const variantImageUrl = variantImagesData.variants[variant.id].featured_image_url;
        if (variantImageUrl) {
          return variantImageUrl;
        }
      }

      if (variant && variant.featured_image && variant.featured_image.src) {
        return variant.featured_image.src;
      }

      if (variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        return variant.featured_media.preview_image.src;
      }

      if (variantImagesData && variantImagesData.product_featured_image_url) {
        return variantImagesData.product_featured_image_url;
      }

      return '';
    }
  
    // Update price display
    function updatePriceDisplay() {
      const variant = findMatchingVariant();
      if (variant) {
        const basePrice = variant.price;
        const totalPrice = calculateTotalPrice(variant);
        
        // Always show a single final price — no crossed-out compare-at price or
        // "X% Off" badge. The discount is baked into the price itself (AMSEC pricing is
        // set at 25% off retail); we don't advertise that as a percentage or show the
        // pre-discount number on these product pages.
        const priceHTML = `
          <div class="price-breakdown">
            <div class="total-price">${formatMoney(totalPrice)}</div>
          </div>
        `;
        
        productPrice.innerHTML = priceHTML;
        
        // Update order summary
        updateOrderSummary(variant, totalPrice);
        
        // Update sticky cart
        updateStickyCart(totalPrice);
      }
    }
  
    // Update order summary
    function updateOrderSummary(variant, totalPrice) {
      const selectedSizeSummary = document.getElementById('selected-size-summary');
      const selectedColorSummary = document.getElementById('selected-color-summary');
      const selectedLockSummary = document.getElementById('selected-lock-summary');
      const selectedUpgradesSummary = document.getElementById('selected-upgrades-summary');
      const totalPriceSummary = document.getElementById('total-price-summary');
      
      // Get the summary row elements
      const colorSummaryRow = document.getElementById('color-summary-row');
      const lockSummaryRow = document.getElementById('lock-summary-row');
      const upgradesSummaryRow = document.getElementById('upgrades-summary-row');
      
      if (selectedSizeSummary) {
        selectedSizeSummary.textContent = selectedSize || 'Not selected';
      }
      
      // Handle color summary - only show if color options exist
      if (selectedColorSummary && colorSummaryRow) {
        selectedColorSummary.textContent = selectedColor || 'Not selected';
        // colorSummaryRow will already be hidden/shown by Liquid logic
      }
      
      // Handle lock summary - only show if lock options exist
      if (selectedLockSummary && lockSummaryRow) {
        selectedLockSummary.textContent = selectedLock || 'Not selected';
        // lockSummaryRow will already be hidden/shown by Liquid logic
      }
      
      // Handle upgrades summary - only show if upgrade options exist
      if (selectedUpgradesSummary && upgradesSummaryRow) {
        if (selectedUpgrade && selectedUpgrade !== 'None') {
          // Format upgrade display text for order summary
          let upgradeDisplayText = selectedUpgrade;
          
          // Check if it's an LED package with colon and pipe separators
          if (selectedUpgrade.includes(':') && selectedUpgrade.includes('|')) {
            const packageName = selectedUpgrade.split(':')[0].trim();
            const afterColon = selectedUpgrade.split(':')[1].trim();
            const parts = afterColon.split('|').map(part => part.trim());
            upgradeDisplayText = `${packageName} includes: ${parts.join(', ')}`;
          } else if (selectedUpgrade.includes('|')) {
            // No colon, just pipe-separated items
            const parts = selectedUpgrade.split('|').map(part => part.trim());
            upgradeDisplayText = `Includes: ${parts.join(', ')}`;
          }
          
          selectedUpgradesSummary.textContent = upgradeDisplayText;
        } else {
          selectedUpgradesSummary.textContent = 'None';
        }
        // upgradesSummaryRow will already be hidden/shown by Liquid logic
      }
      
      if (totalPriceSummary) {
        totalPriceSummary.textContent = formatMoney(totalPrice);
      }
    }
  
    // Keep selected* variables in sync with the current active DOM state
    function syncSelectionsFromDom() {
      const activeSize = document.querySelector('.size-option.active');
      if (activeSize) {
        selectedSize = activeSize.dataset.size;
        window.selectedSize = selectedSize;
      }

      const activeColor = document.querySelector('.color-circle.active, .option-circle.active');
      if (activeColor) {
        const optionValue = activeColor.dataset.color;
        const optionLower = (optionValue || '').toLowerCase();
        const isUpgrade = optionLower.includes('swing out') || optionLower.includes('gun rack') || optionLower.includes('system') || optionLower.includes('add ') || optionLower.includes('do not');

        if (isUpgrade) {
          selectedUpgrade = optionValue;
          selectedColor = null;
          window.selectedUpgrade = selectedUpgrade;
        } else {
          selectedColor = optionValue;
          selectedUpgrade = null;
          window.selectedColor = selectedColor;
        }
      }

      const activeLock = document.querySelector('.lock-option.active');
      if (activeLock) {
        selectedLock = activeLock.dataset.lock;
        window.selectedLock = selectedLock;
      }

      const activeUpgrade = document.querySelector('.upgrade-option.active');
      if (activeUpgrade) {
        selectedUpgrade = activeUpgrade.dataset.upgrade;
        window.selectedUpgrade = selectedUpgrade;
      }

      // Generic options
      document.querySelectorAll('.generic-option-item.active').forEach(function(item) {
        const pos = item.dataset.optionPosition;
        const val = item.dataset.optionValue;
        if (pos && val) {
          selectedOther[pos] = val;
          window.selectedOther = selectedOther;
        }
      });
    }

    // Check if all required selections are made
    function areAllSelectionsComplete() {
      // Ensure we use the latest DOM state (covers cases where clicks didn't set variables)
      syncSelectionsFromDom();
      // Check if size options exist
      const sizeOptions = document.querySelectorAll('.size-option');
      const hasSizeOptions = sizeOptions.length > 0;
      
      // Check if color/option circles exist
      const colorCircles = document.querySelectorAll('.color-circle, .option-circle');
      const hasColorOptions = colorCircles.length > 0;
      
      // Check if lock options exist
      const lockOptions = document.querySelectorAll('.lock-option');
      const hasLockOptions = lockOptions.length > 0;

      const upgradeOptions = document.querySelectorAll('.upgrade-option');
      const hasUpgradeOptions = upgradeOptions.length > 0;
      
      // If size options exist, check if one is selected
      if (hasSizeOptions && !selectedSize) return false;
      if (hasColorOptions && !selectedColor && !selectedUpgrade) return false;
      if (hasUpgradeOptions && !selectedUpgrade) return false;
      if (hasLockOptions && !selectedLock) return false;

      // Generic option pickers (Handle Type, etc.)
      const genericPickers = document.querySelectorAll('.generic-option-picker');
      for (var i = 0; i < genericPickers.length; i++) {
        var pos = genericPickers[i].dataset.optionPosition;
        if (!selectedOther[pos]) return false;
      }

      return true;
    }

    // Reads back whichever image the main gallery is ACTUALLY showing right now
    // (the .sb-gallery__slide currently marked .is-active — see product-gallery.js),
    // rather than independently re-deriving an image URL from the variant the way
    // getStickyVariantImageUrl() does. The two can disagree: the gallery's active
    // slide is whatever updateMainGalleryImageShopifyWay() last selected (by media
    // id or position), while the independent lookup only ever checks
    // featured_image_url and doesn't know about that. Reading the gallery's own
    // DOM state directly guarantees the sticky cart photo always matches what's
    // actually on screen, whatever produced it.
    function getCurrentGalleryImageUrl() {
      if (!productData) return '';
      const gallery = document.querySelector('.sb-gallery[data-product-id="' + productData.id + '"]');
      if (!gallery) return '';
      const activeImg = gallery.querySelector('.sb-gallery__slide.is-active img');
      return activeImg ? activeImg.src : '';
    }

    // Update sticky cart
    function updateStickyCart(totalPrice) {
      const stickyCartPrice = document.getElementById('sticky-cart-price');
      const cartPrice = document.getElementById('cartPrice');
      const stickyCartVariant = document.getElementById('sticky-cart-variant');
      const stickyCartImage = document.getElementById('sticky-cart-image');
      const stickyButtonLabel = document.getElementById('sticky-cart-button-label');
      
      if (stickyCartPrice) {
        stickyCartPrice.textContent = formatMoney(totalPrice);
      }
      
      if (cartPrice) {
        cartPrice.textContent = formatMoney(totalPrice);
      }
      
      // Update button disabled state based on selections and variant availability
      // Make sure our internal selections mirror the UI before matching
      syncSelectionsFromDom();

      const variant = findMatchingVariant();
      const allSelectionsComplete = areAllSelectionsComplete();
      const isDisabled = !allSelectionsComplete || !variant || !variant.available;
      
      const stickyButton = document.getElementById('sticky-add-to-cart');

      if (stickyCartVariant) {
        stickyCartVariant.textContent = getStickyVariantTitle(variant);
      }

      if (stickyCartImage) {
        const stickyImageUrl = getStickyVariantImageUrl(variant);
        if (stickyImageUrl) {
          stickyCartImage.src = stickyImageUrl;
          stickyCartImage.alt = variant && variant.title && variant.title !== 'Default Title'
            ? variant.title
            : productData.title;
        }
      }
      
      if (stickyButton) {
        stickyButton.disabled = isDisabled;
        if (stickyButtonLabel) {
          if (!allSelectionsComplete) {
            stickyButtonLabel.textContent = 'Select All Options';
          } else if (!variant) {
            stickyButtonLabel.textContent = 'Unavailable';
          } else if (!variant.available) {
            stickyButtonLabel.textContent = 'Sold Out';
          } else {
            stickyButtonLabel.textContent = 'Add to Cart';
          }
        }
      }
      
      if (mainAddToCartBtn) {
        mainAddToCartBtn.disabled = isDisabled;
      }
      
      if (addToCartBtn) {
        addToCartBtn.disabled = isDisabled;
        // Update main add to cart button text
        if (!isDisabled) {
          const cartPriceSpan = addToCartBtn.querySelector('#cartPrice');
          if (cartPriceSpan) {
            cartPriceSpan.textContent = formatMoney(totalPrice);
          } else {
            addToCartBtn.innerHTML = `Add to Cart - <span id="cartPrice">${formatMoney(totalPrice)}</span>`;
          }
        } else {
          if (!allSelectionsComplete) {
            addToCartBtn.textContent = 'Select All Options';
          } else if (!variant) {
            addToCartBtn.textContent = 'Out of Stock';
          } else {
            addToCartBtn.textContent = 'Unavailable';
          }
        }
      }
    }
  
    // Update cart properties with all selections
    function updateCartProperties() {
      // Update size property
      const selectedSizeProperty = document.getElementById('selectedSizeProperty');
      if (selectedSizeProperty) {
        selectedSizeProperty.value = selectedSize || '';
      }
      
      // Update color property
      const selectedColorProperty = document.getElementById('selectedColorProperty');
      if (selectedColorProperty) {
        selectedColorProperty.value = selectedColor || '';
      }
      
      // Update lock property
      const selectedLockProperty = document.getElementById('selectedLockProperty');
      if (selectedLockProperty) {
        selectedLockProperty.value = selectedLock || '';
      }
      
      // Update upgrade property
      const selectedUpgradeProperty = document.getElementById('selectedUpgradeProperty');
      if (selectedUpgradeProperty) {
        selectedUpgradeProperty.value = selectedUpgrade || '';
      }
    }
  
    // Update variant and price - using Shopify's standard logic
    function updateSelectedVariant() {
      // Make sure selection variables reflect the current active UI
      syncSelectionsFromDom();

      const variant = findMatchingVariant();
      
      if (variant) {
        
        // Update variant ID
        variantIdInput.value = variant.id;
        
        // Update cart properties with all selections
        updateCartProperties();
        
        // Calculate total price including upgrades
        const totalPrice = calculateTotalPrice(variant);
        
        // Update price displays
        updatePriceDisplay();
        
        // Update sticky cart with the calculated total price
        updateStickyCart(totalPrice);
        
        // Update variant-specific information
        updateVariantInfo(variant);

        // Defensive cleanup in case any legacy script injected old spec rows.
        const specsSection = document.querySelector('.product-specs-section');
        if (specsSection) {
          const allowedLabels = new Set(['capacity', 'weight', 'made in usa', 'warranty']);
          specsSection.querySelectorAll('.spec-item').forEach((item) => {
            const labelEl = item.querySelector('.spec-label');
            const label = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
            if (!allowedLabels.has(label)) {
              item.remove();
            }
          });
        }
  
        // Update gallery image to match the selected variant
        try {
          updateMainGalleryImageShopifyWay(variant);
        } catch (imageError) {
        }

        // Update swing out option image if applicable
        updateSwingOutOptionImage(variant);

        // Sync the sticky cart photo to whatever the gallery ended up actually
        // showing. updateStickyCart() above ran BEFORE this gallery update (it
        // resolves its own best-guess image independently from the variant),
        // so it can't know the real result — this corrects it to match exactly.
        (function () {
          const stickyCartImage = document.getElementById('sticky-cart-image');
          if (!stickyCartImage) return;
          const galleryImageUrl = getCurrentGalleryImageUrl();
          if (galleryImageUrl) stickyCartImage.src = galleryImageUrl;
        })();
        
        // Update button states - check both selections complete AND variant available
        const allSelectionsComplete = areAllSelectionsComplete();
        addToCartBtn.disabled = !allSelectionsComplete || !variant.available;
        
        if (!allSelectionsComplete) {
          addToCartBtn.textContent = 'Select All Options';
        } else if (!variant.available) {
          addToCartBtn.textContent = 'Sold Out';
        } else {
          const cartPriceSpan = addToCartBtn.querySelector('#cartPrice');
          if (cartPriceSpan) {
            cartPriceSpan.textContent = formatMoney(totalPrice);
          }
        }
        
        // Update URL without page reload (optional)
        if (history.replaceState) {
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          history.replaceState(null, '', url);
        }
      } else {
        updateStickyCart(productData ? productData.price : 0);
        
        // Disable buttons and show message
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Select All Options';
        
        const stickyButton = document.getElementById('sticky-add-to-cart');
        if (stickyButton) {
          stickyButton.disabled = true;
          const stickyButtonLabel = document.getElementById('sticky-cart-button-label');
          if (stickyButtonLabel) {
            stickyButtonLabel.textContent = 'Select All Options';
          }
        }
      }
    }
  
    // Update swing out option image based on variant metafield
    function updateSwingOutOptionImage(variant) {
      if (!variant) return;
      
      // Get variant data from embedded JSON
      const productId = productData.id;
      const variantImagesScript = document.getElementById(`variant-images-${productId}`);
      
      if (!variantImagesScript) {
        return;
      }
      
      try {
        const variantData = JSON.parse(variantImagesScript.textContent);
        const variantImageData = variantData.variants[variant.id];
        
        if (!variantImageData || !variantImageData.swing_out_option_image_url) {
          return;
        }
        
        const swingOutImage = variantImageData.swing_out_option_image_url;
        
        // Find all option circles that might be for swing out options
        const optionCircles = document.querySelectorAll('.option-circle');
        
        optionCircles.forEach(circle => {
          const optionValue = circle.dataset.color;
          const optionLower = optionValue ? optionValue.toLowerCase() : '';
          
          // Check if this is a swing out option based on keywords
          const isSwingOutOption = optionLower.includes('swing out') || 
                                   optionLower.includes('gun rack') ||
                                   optionLower.includes('add swing') ||
                                   optionLower.includes('do not add swing');
          
          if (isSwingOutOption && circle.classList.contains('active')) {
            // Find the image element inside this circle
            const optionImg = circle.querySelector('.option-image');
            
            if (optionImg) {
              // Update the image src with the variant's swing out image
              optionImg.src = swingOutImage;
            }
          }
        });
      } catch (error) {
      }
    }
    
    // Shopify's exact logic for updating main gallery image
    function updateMainGalleryImageShopifyWay(variant) {
      if (!variant) return;

      const productId = productData.id;

      // Use the new SBGallery API if available
      const gallery = window.SBGallery && window.SBGallery[productId];
      if (gallery) {
        // Prefer featured_media ID for exact match
        if (variant.featured_media && variant.featured_media.id) {
          gallery.selectImage(variant.featured_media.id);
          return;
        }
        // Fallback: use position
        if (variant.featured_media && variant.featured_media.position) {
          gallery.goTo(variant.featured_media.position - 1);
          return;
        }
        return;
      }

      // Legacy fallback if gallery not yet initialized — try variantImages data
      try {
        const variantImagesScript = document.getElementById('variant-images-' + productId);
        if (!variantImagesScript) return;
        const variantData = JSON.parse(variantImagesScript.textContent);
        const variantImageData = variantData.variants[variant.id];
        if (!variantImageData) return;

        // Find the slide with matching image URL and activate it
        const slides = document.querySelectorAll('#sb-gallery-main-' + productId + ' .sb-gallery__slide');
        slides.forEach(function(slide) {
          const img = slide.querySelector('img');
          if (!img) return;
          const matchUrl = variantImageData.featured_image_url;
          if (matchUrl && img.src.includes(matchUrl.split('?')[0].split('/').pop().split('_')[0])) {
            slides.forEach(function(s) { s.classList.remove('is-active'); });
            slide.classList.add('is-active');
          }
        });
      } catch (e) {}
    }
  
    // Update delivery price display
    if (deliverySelect) {
      deliverySelect.addEventListener('change', function() {
        selectedDelivery = parseInt(this.value);
        updatePriceDisplay();
      });
    }
  
    // Update dimensions display for new layout
    function updateDimensionsDisplay(variant) {
      // Update dimensions in the simplified single-line format
      const dimensionValue = document.querySelector('.dimensions-display .dimension-value');
      const dimensionsDisplay = document.querySelector('.dimensions-display');
      
      if (dimensionValue && dimensionsDisplay) {
        if (variant.metafields && variant.metafields.custom && variant.metafields.custom.exterior_dimensions) {
          const newValue = variant.metafields.custom.exterior_dimensions;
          dimensionValue.textContent = newValue;
          dimensionsDisplay.style.display = 'block';
        } else if (variant.option1 && variant.option1.includes('"')) {
          // Extract dimensions from size name
          let dimensionText = variant.option1;
          if (dimensionText.includes(' | Dimensions: ')) {
            const parts = dimensionText.split(' | Dimensions: ');
            dimensionText = parts[1];
          } else if (dimensionText.includes(' | ') && dimensionText.includes('"')) {
            const parts = dimensionText.split(' | ');
            if (parts.length > 1) {
              dimensionText = parts[1];
            }
          }
          dimensionValue.textContent = dimensionText;
          dimensionsDisplay.style.display = 'block';
        } else {
          dimensionsDisplay.style.display = 'none';
        }
      }
    }

    // Update variant-specific information
    function updateVariantInfo(variant) {
      // Update dimensions display for new layout
      updateDimensionsDisplay(variant);

      // Get the active size option to access metafield data
      const activeSizeOption = document.querySelector('.size-option.active');
      
      
      // Update gun capacity
      const gunCapacityElement = document.querySelector('#variantGunCapacity .info-text');
      const gunCapacityContainer = document.querySelector('#variantGunCapacity');
      if (gunCapacityElement && gunCapacityContainer) {
        const gunCapacity = activeSizeOption?.dataset.gunCapacity;

        // Check if variant-level gun capacity exists and has a valid value
        const hasVariantGunCapacity = gunCapacity &&
                                     gunCapacity !== 'null' &&
                                     gunCapacity !== '' &&
                                     gunCapacity !== 'undefined' &&
                                     gunCapacity.trim() !== '';

        if (hasVariantGunCapacity) {
          gunCapacityElement.textContent = Number(gunCapacity) === 0 ? 'None' : `Up to ${gunCapacity} long guns`;
          gunCapacityContainer.style.display = 'flex'; // Show the container
        } else {
          // Fallback to product-level gun_count (or long_gun_capacity, the actual key most products use)
          const productGunCount = productData.metafields?.custom?.gun_count ?? productData.metafields?.custom?.long_gun_capacity;

          // Check if product-level gun count exists and has a valid value
          const hasProductGunCount = productGunCount &&
                                    productGunCount !== 'null' &&
                                    productGunCount !== '' &&
                                    productGunCount !== 'undefined' &&
                                    productGunCount.toString().trim() !== '';

          if (hasProductGunCount) {
            gunCapacityElement.textContent = Number(productGunCount) === 0 ? 'None' : `Up to ${productGunCount} long guns`;
            gunCapacityContainer.style.display = 'flex'; // Show the container
          } else {
            // Hide the entire gun capacity section when no valid data is available
            gunCapacityContainer.style.display = 'none';
          }
        }
      }
  
      // Update weight
      const weightElement = document.querySelector('#variantWeight .info-text');
      if (weightElement) {
        const weight = activeSizeOption?.dataset.weight;
        if (weight && weight !== 'null' && weight !== '') {
          weightElement.textContent = `${Number(weight).toLocaleString('en-US')} lbs`;
        } else if (variant.weight) {
          // Convert grams to pounds if needed
          const weightInPounds = variant.weight > 1000 ? Math.round(variant.weight * 0.00220462) : variant.weight;
          weightElement.textContent = `${weightInPounds.toLocaleString('en-US')} lbs`;
        } else {
          weightElement.textContent = 'Weight: TBA';
        }
      }
  
      // Update fire rating — some products (e.g. Centurion) genuinely rate different sizes
      // differently (30 min on 12/18, 40 min on 24/32) even though the server-rendered default
      // is one flat product-level value; data-fire-rating-minutes carries the per-size override
      // when safe-builder.liquid found one, so the summary box tracks the selected size instead
      // of always showing whatever size happened to render first.
      const fireRatingElement = document.querySelector('#fireRatingSummaryValue');
      if (fireRatingElement && activeSizeOption) {
        const fireMinutes = activeSizeOption.dataset.fireRatingMinutes;
        if (fireMinutes && fireMinutes !== 'null' && fireMinutes !== '' && Number(fireMinutes) > 0) {
          // Temperature is product-level (TL-rated AMSEC lines run 1850°F, not the 1200°F standard);
          // fall back to 1200 only when the product has no fire_rating_temp metafield.
          const fireTemp = activeSizeOption.dataset.fireRatingTemp;
          const tempLabel = fireTemp && fireTemp !== 'null' && Number(fireTemp) > 0 ? Number(fireTemp) : 1200;
          fireRatingElement.textContent = `${fireMinutes} min at ${tempLabel}°F`;
        }
      }

      // Update delivery options
      updateDeliveryOptions(activeSizeOption);

      // Update Product Specs Section
      updateProductSpecs(variant, activeSizeOption);
  
      // Update external dimensions
      const externalDimensionsElement = document.querySelector('#variantExternalDimensions .info-text');
      const externalDimensionsContainer = document.querySelector('#variantExternalDimensions');
      let hasExternalDimensions = false;
      if (activeSizeOption && externalDimensionsElement && externalDimensionsContainer) {
        const externalDimensions = activeSizeOption.dataset.externalDimensions;
        if (externalDimensions && externalDimensions !== 'null' && externalDimensions !== '') {
          externalDimensionsElement.textContent = `External: ${externalDimensions}`;
          externalDimensionsContainer.style.display = 'flex';
          hasExternalDimensions = true;
        } else {
          externalDimensionsContainer.style.display = 'none';
        }
      }
  
      // Update internal dimensions
      const internalDimensionsElement = document.querySelector('#variantInternalDimensions .info-text');
      const internalDimensionsContainer = document.querySelector('#variantInternalDimensions');
      let hasInternalDimensions = false;
      if (activeSizeOption && internalDimensionsElement && internalDimensionsContainer) {
        const internalDimensions = activeSizeOption.dataset.internalDimensions;
        if (internalDimensions && internalDimensions !== 'null' && internalDimensions !== '') {
          internalDimensionsElement.textContent = `Internal: ${internalDimensions}`;
          internalDimensionsContainer.style.display = 'flex';
          hasInternalDimensions = true;
        } else {
          internalDimensionsContainer.style.display = 'none';
        }
      }
  
      // Update dimensions - Complete logic (fallback dimensions only if specific dimensions not available)
      const dimensionsElement = document.querySelector('#variantDimensions .info-text');
      const dimensionsContainer = document.querySelector('#variantDimensions');
      
      // Only show fallback dimensions if we don't have specific external/internal dimensions
      if (dimensionsElement && dimensionsContainer && variant.option1 && (!hasExternalDimensions && !hasInternalDimensions)) {
        const sizeName = variant.option1;
        let dimensions = 'Dimensions: TBA';
        
        // Show the fallback container
        dimensionsContainer.style.display = 'flex';
        
        // Pattern 1: Look for dimensions after " - "
        if (sizeName.includes(' - ')) {
          const parts = sizeName.split(' - ');
          if (parts.length > 1) {
            const lastPart = parts[parts.length - 1];
            // Check if the last part contains dimension-like content
            if (lastPart.includes('"') || lastPart.includes('x') || lastPart.includes('X')) {
              dimensions = lastPart;
            }
          }
        }
        
        // Pattern 2: Look for dimension pattern directly in the string
        if (dimensions === 'Dimensions: TBA') {
          // Look for patterns like "60.5"x 30"x 24"" or "60.5" x 30" x 24""
          const dimensionPattern = /(\d+\.?\d*"?\s*[xX]\s*\d+\.?\d*"?\s*[xX]\s*\d+\.?\d*"?)/;
          const match = sizeName.match(dimensionPattern);
          if (match) {
            dimensions = match[1];
          } else {
            // Look for simpler patterns like "60x30x24"
            const simplePattern = /(\d+\.?\d*\s*[xX]\s*\d+\.?\d*\s*[xX]\s*\d+\.?\d*)/;
            const simpleMatch = sizeName.match(simplePattern);
            if (simpleMatch) {
              dimensions = simpleMatch[1];
            }
          }
        }
        
        // Pattern 3: If still not found, try to extract anything with quotes and x
        if (dimensions === 'Dimensions: TBA' && sizeName.includes('"')) {
          // Look for any sequence with quotes and x
          const quotePattern = /(\d+\.?\d*"[^"]*[xX][^"]*\d+\.?\d*"[^"]*[xX][^"]*\d+\.?\d*")/;
          const quoteMatch = sizeName.match(quotePattern);
          if (quoteMatch) {
            dimensions = quoteMatch[1];
          }
        }
        
        // Pattern 4: Last resort - if it has dimensions somewhere, try to find them
        if (dimensions === 'Dimensions: TBA') {
          // Split by common separators and look for dimension-like strings
          const words = sizeName.split(/[\s\-,]+/);
          for (let word of words) {
            if (word.includes('x') || word.includes('X')) {
              const parts = word.split(/[xX]/);
              if (parts.length >= 3 && parts.every(part => /\d/.test(part))) {
                dimensions = word;
                break;
              }
            }
          }
        }
        
        // Pattern 5: Try extracting dimensions from the end of the string
        if (dimensions === 'Dimensions: TBA') {
          // Look for dimensions at the end like "Model Name - 60.5" x 30" x 24""
          const endPattern = /(\d+\.?\d*"\s*x\s*\d+\.?\d*"\s*x\s*\d+\.?\d*")$/i;
          const endMatch = sizeName.match(endPattern);
          if (endMatch) {
            dimensions = endMatch[1];
          }
        }
        
        // Clean up the dimensions string
        if (dimensions !== 'Dimensions: TBA') {
          // Clean up extra spaces and standardize format
          dimensions = dimensions.replace(/\s+/g, ' ').trim();
          // Ensure it doesn't start with unwanted characters
          dimensions = dimensions.replace(/^[^\d]*([\d"].*)/, '$1');
          // Standardize x separators
          dimensions = dimensions.replace(/\s*[xX]\s*/g, ' x ');
        }
        
        dimensionsElement.textContent = dimensions;
      } else if (dimensionsContainer) {
        // Hide fallback dimensions if we have specific external/internal dimensions or no variant
        dimensionsContainer.style.display = 'none';
      }
    }

    // Function to update Product Specs section
    function updateProductSpecs(variant, activeSizeOption) {
      if (!variant) return;

      // A product with no .size-option elements at all (single-variant, e.g. an accessory
      // like Ammo Can — see has_size_options in safe-builder.liquid) has no size for a
      // shopper to select, so "Select a size to view" is never actually correct for it.
      // Worse, the capacity fallback chain below only checks the active size option's data
      // attribute and the product-level gun_count metafield — it doesn't know about the
      // capacity.long_guns/specs.gun_capacity metafields safe-builder.liquid itself already
      // read to render the real value server-side, so it silently overwrote a correct
      // Liquid-rendered value with that placeholder. Skip the whole block for such products
      // and leave the server-rendered (real) text alone.
      const hasSizeOptions = document.querySelector('.size-option') !== null;

      // Update Capacity
      const capacityElement = document.querySelector('#specCapacityValue');
      const capacityItem = document.querySelector('#specCapacity');
      if (capacityElement && capacityItem && hasSizeOptions) {
        const gunCapacity = activeSizeOption?.dataset.gunCapacity;

        if (gunCapacity && gunCapacity !== 'null' && gunCapacity !== '' && gunCapacity !== 'undefined' && gunCapacity.trim() !== '') {
          capacityElement.textContent = Number(gunCapacity) === 0 ? 'None' : `Up to ${gunCapacity} guns`;
          capacityItem.style.display = 'flex';
        } else {
          // Fallback to product-level gun_count (or long_gun_capacity, the actual key most products use)
          const productGunCount = productData?.metafields?.custom?.gun_count ?? productData?.metafields?.custom?.long_gun_capacity;
          if (productGunCount && productGunCount !== 'null' && productGunCount !== '' && productGunCount !== 'undefined' && productGunCount.toString().trim() !== '') {
            capacityElement.textContent = Number(productGunCount) === 0 ? 'None' : `Up to ${productGunCount} guns`;
            capacityItem.style.display = 'flex';
          } else {
            // Non-gun-safe capacity (commercial/depository safes, cabinets, etc.) — cubic feet
            // instead of "None", same fallback as the server-rendered initial state in
            // safe-builder.liquid. Client feedback 2026-09-23.
            const cubicFt = activeSizeOption?.dataset.cubicFt || productData?.metafields?.custom?.cubic_ft;
            if (cubicFt && cubicFt !== 'null' && cubicFt !== '' && cubicFt !== 'undefined' && cubicFt.toString().trim() !== '' && Number(cubicFt) !== 0) {
              capacityElement.textContent = `${cubicFt} cu. ft.`;
              capacityItem.style.display = 'flex';
            } else {
              // A size IS selected at this point (this function only runs after
              // a size click) — it just has no capacity data for that size, so
              // say so plainly instead of the "Select a size to view" prompt,
              // which is wrong once a size has already been chosen.
              capacityElement.textContent = activeSizeOption ? 'None' : 'Select a size to view';
              capacityItem.style.display = 'flex';
            }
          }
        }
      }

      // Update Internal Dimensions
      const internalElement = document.querySelector('#specInternalValue');
      const internalItem = document.querySelector('#specInternal');
      if (internalElement && internalItem) {
        const internalDimensions = activeSizeOption?.dataset.internalDimensions;
        
        if (internalDimensions && internalDimensions !== 'null' && internalDimensions !== '' && internalDimensions !== 'undefined' && internalDimensions.trim() !== '') {
          internalElement.textContent = internalDimensions;
          internalItem.style.display = 'block';
        } else {
          internalItem.style.display = 'none';
        }
      }

      // Update Weight
      const weightElement = document.querySelector('#specWeightValue');
      const weightItem = document.querySelector('#specWeight');
      if (weightElement && weightItem) {
        const weight = activeSizeOption?.dataset.weight;
        
        if (weight && weight !== 'null' && weight !== '' && weight !== 'undefined') {
          weightElement.textContent = `${Number(weight).toLocaleString('en-US')} lbs`;
          weightItem.style.display = 'flex';
        } else if (variant.weight) {
          // Convert grams to pounds if weight is in grams
          const weightInPounds = variant.weight > 1000 ? Math.round(variant.weight * 0.00220462) : variant.weight;
          weightElement.textContent = `${weightInPounds.toLocaleString('en-US')} lbs`;
          weightItem.style.display = 'flex';
        } else {
          weightElement.textContent = 'Select a size to view';
          weightItem.style.display = 'flex';
        }
      }
    }
  
    // Update variant metafields display — rows live inside .specs-grid
    function updateVariantMetafields(variant) {
      return;
    }

    // New function to update delivery options with all 5 metafields
    function updateDeliveryOptions(activeSizeOption) {
    const deliverySelect = document.getElementById('deliverySelect');
    const deliveryItem = document.querySelector('.delivery-item');
    if (!deliverySelect || !activeSizeOption || !deliveryItem) return;
  
    // Get all delivery options from variant metafields
    const deliveryStartingAt = activeSizeOption.dataset.deliveryStartingAt;
    const deliveryPickup = activeSizeOption.dataset.deliveryPickup;
    const deliveryStairs = activeSizeOption.dataset.deliveryStairs;
    const deliveryInhome = activeSizeOption.dataset.deliveryInhome;
    const deliveryCurbside = activeSizeOption.dataset.deliveryCurbside;
  
    // Clear existing options
    deliverySelect.innerHTML = '';
  
    // Helper function to parse price from string
    function parsePrice(value) {
      if (!value || value === 'null' || value === '') return null;
      
      if (value.toLowerCase().includes('free')) {
        return 0;
      }
      
      const priceMatch = value.match(/\$?(\d+(?:\.\d{2})?)/);
      return priceMatch ? parseFloat(priceMatch[1]) : null;
    }
  
    // Build delivery options array
    const deliveryOptions = [];
  
    // Add pickup option if available
    if (deliveryPickup && deliveryPickup !== 'null' && deliveryPickup !== '') {
      const price = parsePrice(deliveryPickup);
      const safePrice = price !== null ? price : 0;
      deliveryOptions.push({
        value: safePrice,
        label: safePrice === 0 ? 'Pickup - Free' : `Pickup - $${safePrice.toFixed(2)}`,
        type: 'pickup'
      });
    }
  
    // Add curbside delivery option if available
    if (deliveryCurbside && deliveryCurbside !== 'null' && deliveryCurbside !== '') {
      const price = parsePrice(deliveryCurbside);
      const safePrice = price !== null ? price : 0;
      deliveryOptions.push({
        value: safePrice,
        label: safePrice === 0 ? 'Curbside - Free' : `Curbside - $${safePrice.toFixed(2)}`,
        type: 'curbside'
      });
    }
  
    // Add in-home delivery option if available
    if (deliveryInhome && deliveryInhome !== 'null' && deliveryInhome !== '') {
      const price = parsePrice(deliveryInhome);
      const safePrice = price !== null ? price : 0;
      deliveryOptions.push({
        value: safePrice,
        label: safePrice === 0 ? 'In-Home - Free' : `In-Home - $${safePrice.toFixed(2)}`,
        type: 'inhome'
      });
    }
  
    // Add stairs delivery option if available
    if (deliveryStairs && deliveryStairs !== 'null' && deliveryStairs !== '') {
      const price = parsePrice(deliveryStairs);
      const safePrice = price !== null ? price : 0;
      deliveryOptions.push({
        value: safePrice,
        label: safePrice === 0 ? 'With Stairs - Free' : `With Stairs - $${safePrice.toFixed(2)}`,
        type: 'stairs'
      });
    }
  
    // Add default pickup option if no options are available
    if (deliveryOptions.length === 0) {
      deliveryOptions.push({
        value: 0,
        label: 'Pickup - Free',
        type: 'pickup'
      });
    }
  
    // Sort options by price (free options first, then by ascending price)
    deliveryOptions.sort((a, b) => {
      if (a.value === 0 && b.value !== 0) return -1;
      if (a.value !== 0 && b.value === 0) return 1;
      return a.value - b.value;
    });
  
    // Update the delivery item header with starting price
    const infoText = deliveryItem.querySelector('.info-text');
    if (infoText) {
      const startingPrice = parsePrice(deliveryStartingAt);
      if (startingPrice !== null && startingPrice > 0) {
        infoText.textContent = `Professional Installation: (Starting at $${startingPrice.toFixed(2)})`;
      } else {
        infoText.textContent = 'Professional Installation:';
      }
    }
  
    // Populate the select dropdown with installation options
    deliveryOptions.forEach((option, index) => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value;
      optionElement.textContent = option.label;
      optionElement.dataset.type = option.type;
      
      // Select the first option by default
      if (index === 0) {
        optionElement.selected = true;
        selectedDelivery = option.value;
      }
      
      deliverySelect.appendChild(optionElement);
    });
  
    // Update the price display after changing delivery options
    updatePriceDisplay();
    
  }
  
    // Function to fetch variant metafields via AJAX
    async function fetchVariantMetafields(variantId) {
      try {
        const response = await fetch(`/products/${productData.handle}.js`);
        const productJson = await response.json();
        
        // Find the specific variant in the response
        const variant = productJson.variants.find(v => v.id === variantId);
        
        if (variant) {
          // Shopify doesn't include metafields in the .js endpoint, so let's try a different approach
          // We'll use the variant ID to construct a URL that gives us metafields
          const metafieldResponse = await fetch(`/variants/${variantId}.json`);
          
          if (metafieldResponse.ok) {
            const variantData = await metafieldResponse.json();
            return variantData.variant;
          } else {
            // If that doesn't work, let's try using the Admin API format
            throw new Error('Metafields not available via standard endpoint');
          }
        }
        
        return variant || {};
      } catch (error) {
        
        // Alternative approach: check if metafields are embedded in the page
        const variantElement = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (variantElement) {
          const gunCapacity = variantElement.dataset.gunCapacity;
          const weight = variantElement.dataset.weight;
          
          return {
            metafields: {
              custom: {
                variant_gun_capacity: gunCapacity,
                weight: weight
              }
            }
          };
        }
        
        return {};
      }
    }
  
    // Setup event listeners
    sizeOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        
        // Ensure we're not clicking on the expand icon
        if (e.target.closest('.expand-icon')) {
          return;
        }
        
        sizeOptions.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');
        selectedSize = this.dataset.size;
        window.selectedSize = selectedSize; // Update global reference

        // Filter swing out gun rack options based on selected size
        if (window.filterSwingOutOptions) {
          window.filterSwingOutOptions();
        }
        // Hide color/finish swatches not offered for this size
        if (window.filterColorOptionsBySize) {
          window.filterColorOptionsBySize();
        }

        // Update selection displays
        updateSelectionDisplays();

        // Update variant using Shopify's standard method
        updateSelectedVariant();
      });

      // Add touch event for better mobile responsiveness
      option.addEventListener('touchend', function(e) {

        // Ensure we're not touching the expand icon
        if (e.target.closest('.expand-icon')) {
          return;
        }

        // Prevent the click event from firing after touchend
        e.preventDefault();

        // Manually trigger the selection logic
        sizeOptions.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');
        selectedSize = this.dataset.size;

        // Filter swing out gun rack options based on selected size
        if (window.filterSwingOutOptions) {
          window.filterSwingOutOptions();
        }
        // Hide color/finish swatches not offered for this size
        if (window.filterColorOptionsBySize) {
          window.filterColorOptionsBySize();
        }

        // Update selection displays
        updateSelectionDisplays();
        
        // Update variant using Shopify's standard method
        updateSelectedVariant();
      });
    });
  
    colorCircles.forEach(circle => {
      circle.addEventListener('click', function() {
        // Remove active class from all color and option circles
        document.querySelectorAll('.color-circle, .option-circle').forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        
        // Check if this is actually an upgrade option (like Swing Out Gun Rack)
        const optionValue = this.dataset.color;
        const optionLower = optionValue.toLowerCase();
        
        // Detect if this is an upgrade option based on keywords
        const isUpgrade = optionLower.includes('swing out') || 
                         optionLower.includes('gun rack') ||
                         optionLower.includes('system') ||
                         optionLower.includes('add ') ||
                         optionLower.includes('do not');
        
        if (isUpgrade) {
          selectedUpgrade = optionValue;
          selectedColor = null; // Clear color selection if this is actually an upgrade
          window.selectedUpgrade = selectedUpgrade;
        } else {
          selectedColor = optionValue;
          selectedUpgrade = null; // Clear any stale upgrade when picking a normal color
          window.selectedColor = selectedColor;
        }
        
        // Update selection displays
        updateSelectionDisplays();
        
        // Update variant using Shopify's standard method
        updateSelectedVariant();
      });
    });
  
    lockOptions.forEach(option => {
      option.addEventListener('click', function() {
        lockOptions.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');
        selectedLock = this.dataset.lock;
        window.selectedLock = selectedLock; // Update global reference
        
        // Update selection displays
        updateSelectionDisplays();
        
        // Update variant using Shopify's standard method
        updateSelectedVariant();
      });
    });
  
    // Upgrade options event listeners (for both color and lock upgrade sections)
    const upgradeOptions = document.querySelectorAll('.upgrade-option');
    upgradeOptions.forEach(option => {
      // Handle close button clicks separately to prevent event bubbling
      const closeBtn = option.querySelector('.close-btn');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
  
          // Remove active state from this upgrade option
          option.classList.remove('active');
  
          // Clear the selected upgrade
          selectedUpgrade = null;
  
          // Update selection displays
          updateSelectionDisplays();
  
          // Update variant using Shopify's standard method
          updateSelectedVariant();
  
        });
      }
  
      // Handle main upgrade option selection (excluding close button)
      option.addEventListener('click', function(e) {
        // Don't trigger selection if clicking on close button
        if (e.target.closest('.close-btn')) {
          return;
        }
  
        // Remove active from all upgrade options in the same section
        const parentSection = this.closest('.upgrade-picker');
        const sectionUpgradeOptions = parentSection.querySelectorAll('.upgrade-option');
        sectionUpgradeOptions.forEach(opt => opt.classList.remove('active'));
  
        this.classList.add('active');
  
        // Use the full upgrade text for processing, but store display text for UI
        const fullUpgradeText = this.dataset.upgrade;
        const displayText = this.dataset.displayText || fullUpgradeText;
  
        selectedUpgrade = fullUpgradeText; // Keep full text for variant matching
  
        // Update selection displays
        updateSelectionDisplays();
  
        // Update the appropriate option based on the upgrade location
        if (parentSection.id && parentSection.id.startsWith('upgradeOptions-')) {
          // This is a standard upgrade picker
          // selectedUpgrade is already set above — no extra color assignment needed
        } else if (parentSection.classList.contains('lock-upgrade')) {
          // This is lock section upgrade
          selectedLock = selectedUpgrade;
        }

        // Sync state after selection
        syncSelectionsFromDom();
  
        // Update variant using Shopify's standard method
        updateSelectedVariant();
      });
    });
  
      // Generic option picker (Handle Type, etc.)
      const genericItems = document.querySelectorAll('.generic-option-item');
      genericItems.forEach(function(item) {
        item.addEventListener('click', function() {
          const pos = this.dataset.optionPosition;
          const val = this.dataset.optionValue;

          // Deactivate siblings
          document.querySelectorAll('.generic-option-item[data-option-position="' + pos + '"]').forEach(function(el) {
            el.classList.remove('active');
          });

          this.classList.add('active');
          selectedOther[pos] = val;
          window.selectedOther = selectedOther;

          // Update display
          const display = document.querySelector('.generic-option-display[data-option-position="' + pos + '"]');
          if (display) display.textContent = val;

          const variant = findMatchingVariant();
          if (variant) {
            updateVariantInfo(variant);
            updateMainGalleryImageShopifyWay(variant);
            const totalPrice = calculateTotalPrice(variant);
            updatePriceDisplay(totalPrice, variant);
            updateStickyCart(totalPrice);
          }
        });
      });

    // Delivery selection event listener
    if (deliverySelect) {
      deliverySelect.addEventListener('change', function() {
        selectedDelivery = parseInt(this.value);

        // Update cart properties and price display
        updateCartProperties();
        updatePriceDisplay();
      });
    }
  
    // New delivery selection event listener for order summary section
    const deliverySelectNew = document.getElementById('deliverySelectNew');
    if (deliverySelectNew) {
      deliverySelectNew.addEventListener('change', function() {
        selectedDelivery = parseInt(this.value);
        
        // Update cart properties and price display
        updateCartProperties();
        updatePriceDisplay();
      });
    }
  
    // Check URL for pre-selected variant
    const urlParams = new URLSearchParams(window.location.search);
    const preSelectedVariantId = urlParams.get('variant');
    
    if (preSelectedVariantId) {
      // Find the variant in product data
      const preSelectedVariant = productData.variants.find(v => v.id == preSelectedVariantId);
      
      if (preSelectedVariant) {
        
        // Extract options from variant
        const variantSize = preSelectedVariant.option1;
        const variantColor = preSelectedVariant.option2;
        const variantLock = preSelectedVariant.option3;
        
        // Pre-select size
        if (variantSize) {
          const sizeOption = Array.from(sizeOptions).find(opt => {
            const optionSize = opt.getAttribute('data-size');
            return optionSize === variantSize;
          });
          
          if (sizeOption) {
            sizeOption.click();
            selectedSize = variantSize;
          }
        }
        
        // Pre-select color if exists
        if (variantColor && variantColor !== 'Default Color') {
          const colorOption = Array.from(colorCircles).find(circle => {
            const circleColor = circle.getAttribute('data-color');
            return circleColor === variantColor;
          });
          
          if (colorOption) {
            colorOption.click();
            selectedColor = variantColor;
          }
        }
        
        // Pre-select lock if exists
        if (variantLock && variantLock !== 'Default Lock') {
          const lockOption = Array.from(lockOptions).find(opt => {
            const optLock = opt.getAttribute('data-lock');
            return optLock === variantLock;
          });
          
          if (lockOption) {
            lockOption.click();
            selectedLock = variantLock;
          }
        }
        
        // Update everything
        updateSelectedVariant();
        updateSelectionDisplays();
        updateCartProperties();
      }
    }
    
    
    // Make functions globally accessible for inline JavaScript
    window.updateSelectedVariant = updateSelectedVariant;
    window.findMatchingVariant = findMatchingVariant;
    window.calculateTotalPrice = calculateTotalPrice;
    window.updateCartProperties = updateCartProperties;
    window.selectedSize = selectedSize;
    window.selectedColor = selectedColor;
    window.selectedLock = selectedLock;
    window.selectedUpgrade = selectedUpgrade;
    
    // Debug function to test pricing
    window.debugPricing = function() {
      
      const variant = findMatchingVariant();
      
      if (variant) {
        const totalPrice = calculateTotalPrice(variant);
        
        // Check cart properties
        const properties = {
          size: document.getElementById('selectedSizeProperty')?.value,
          color: document.getElementById('selectedColorProperty')?.value,
          lock: document.getElementById('selectedLockProperty')?.value,
          upgrade: document.getElementById('selectedUpgradeProperty')?.value,
          totalPrice: document.getElementById('totalPriceProperty')?.value,
          installation: ''  // Removed installation pricing
        };
      }
      
      // Test upgrade cost extraction
      if (selectedUpgrade) {
        const upgradeCost = extractUpgradeCost(selectedUpgrade);
      }
      
      // Test lock cost extraction
      if (selectedLock) {
        const lockCost = extractPriceFromOption(selectedLock);
      }
      
      // Show all variants for current size
      if (selectedSize && productData.variants) {
        const sizeVariants = productData.variants.filter(v => v.option1 === selectedSize);
        sizeVariants.forEach(v => {
        });
      }
      
    };
    
    // Debug function to analyze product structure
    window.debugProductStructure = function() {
      if (productData && productData.variants) {
        
        // Group by size
        const sizeGroups = {};
        productData.variants.forEach(variant => {
          const size = variant.option1;
          if (!sizeGroups[size]) sizeGroups[size] = [];
          sizeGroups[size].push(variant);
        });
        
        Object.keys(sizeGroups).forEach(size => {
          sizeGroups[size].forEach(variant => {
          });
        });
      }
    };
  
    // Debug function to test cart functionality
    window.debugCartIssue = function() {
      
      // Check current selections
      const variant = findMatchingVariant();
      
      if (variant) {
        // Check form inputs
        const formInputs = {
          variantId: document.getElementById('variantId')?.value,
          quantity: document.querySelector('input[name="quantity"]')?.value,
          size: document.getElementById('selectedSizeProperty')?.value,
          color: document.getElementById('selectedColorProperty')?.value,
          lock: document.getElementById('selectedLockProperty')?.value,
          upgrade: document.getElementById('selectedUpgradeProperty')?.value
        };
        
        // Test if variant exists in Shopify's variant array
        const shopifyVariant = productData.variants.find(v => v.id === variant.id);
        
        if (!shopifyVariant) {
        }
        
        // Check if price is valid
        if (variant.price === 0 || variant.price === null || variant.price === undefined) {
        }
        
      } else {
      }
      
    };
    
    // Initialize order summary with current state
    const currentVariant = findMatchingVariant();
    if (currentVariant) {
      const totalPrice = calculateTotalPrice(currentVariant);
      updateOrderSummary(currentVariant, totalPrice);
      updateStickyCart(totalPrice);
    }
    
    // Add form submit event listener to ensure properties are up-to-date
    const productForm = document.getElementById('productForm');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        // Update cart properties one more time before submission
        updateCartProperties();
        
        // Allow normal form submission
        return true;
      });
    }
    
    // Default-select the first choice in every required option group that
    // doesn't already have an active selection — mirrors Shopify's own
    // variant picker, which always lands on a real variant instead of a
    // blank "choose an option" state. Without this, a product page loads
    // with no variant matched at all: gallery/price/cart button all sit in
    // their "nothing selected" state until the shopper clicks something,
    // even though there's always a real default variant
    // (product.selected_or_first_available_variant) they could see instead.
    // Runs after URL-param preselection above, and only fires when nothing
    // is active yet so it never overrides that (or a real prior choice).
    // .click() (not direct state assignment) so every existing click-handler
    // side effect (gallery image, price, sticky cart, cart properties) runs
    // exactly as if the shopper had clicked it themselves.
    if (sizeOptions.length > 0 && !document.querySelector('.size-option.active')) {
      sizeOptions[0].click();
    }
    if (colorCircles.length > 0 && !document.querySelector('.color-circle.active, .option-circle.active')) {
      colorCircles[0].click();
    }
    if (lockOptions.length > 0 && !document.querySelector('.lock-option.active')) {
      lockOptions[0].click();
    }
    // Upgrade options are real optional add-ons (extra cost, e.g. a gun rack
    // or LED package). Auto-select when there's just one, same as before —
    // defaulting to the first of several would silently add a paid upgrade
    // nobody chose. When there are multiple, default to the explicit "no
    // upgrade" opt-out option if one exists (e.g. "No Swing Out Gun Rack
    // System") — that's a real, no-cost default, not an arbitrary pick.
    document.querySelectorAll('.upgrade-picker').forEach(function(picker) {
      const opts = picker.querySelectorAll('.upgrade-option');
      if (picker.querySelector('.upgrade-option.active')) return;

      if (opts.length === 1) {
        opts[0].click();
        return;
      }

      const noUpgradeOption = Array.from(opts).find(opt => {
        const value = (opt.dataset.upgrade || '').toLowerCase();
        return value.startsWith('no ') || value.includes('no upgrade');
      });
      if (noUpgradeOption) {
        noUpgradeOption.click();
      }
    });
    document.querySelectorAll('.generic-option-picker').forEach(function(picker) {
      const items = picker.querySelectorAll('.generic-option-item');
      if (items.length > 0 && !picker.querySelector('.generic-option-item.active')) {
        items[0].click();
      }
    });

    updateSelectedVariant();

    // Initialize selection displays
    updateSelectionDisplays();
    
    // Initialize swing out gun rack options filtering based on selected size
    if (window.filterSwingOutOptions) {
      window.filterSwingOutOptions();
    }
    
    // Initialize cart properties
    updateCartProperties();
  
    // Initialize desktop swipe for thumbnails
    initializeDesktopSwipe();
  
    // Desktop swipe functionality for thumbnail gallery
    function initializeDesktopSwipe() {
      const thumbnailContainer = document.querySelector('.product-gallery__thumbnails');
      const mainGallery = document.querySelector('.product-gallery__main');
      
      if (!thumbnailContainer && !mainGallery) {
        return;
      }
    }
  
    window.analyzeVariantFormat = function() {
      
      if (!productData) {
        return;
      }
      
      productData.variants.forEach((variant, index) => {
      });
    };
    
    // Function to setup alt text for images (helper for theme editor)
    window.setupImageAltText = function() {
      
      const images = document.querySelectorAll('.product__images img, .size-image, .lock-image, .color-circle');
      images.forEach((img, index) => {
        if (!img.alt || img.alt === '') {
          img.alt = `Product image ${index + 1}`;
        }
      });
    };
  
    // Debug function for tooltips
    window.debugTooltips = function() {
      const tooltipElements = document.querySelectorAll('[data-tooltip]');
      const tooltipDiv = document.getElementById('tooltip');
      
      tooltipElements.forEach((el, index) => {
      });
      
      if (tooltipElements.length > 0) {
        const firstElement = tooltipElements[0];
        firstElement.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
        
        setTimeout(() => {
          firstElement.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
        }, 2000);
      }
    };
  
    // Function to analyze variant naming format
    window.analyzeVariantFormat = function() {
      // Analyze all variants
      const allVariants = productData.variants;
      allVariants.forEach((variant, index) => {
        const title = variant.title || `${variant.option1} / ${variant.option2} / ${variant.option3}`;
        const parts = title.split(' / ');
        
        
        if (parts.length >= 1) {
          const sizeMatch = parts[0].match(/^(\d+)/);
        }
        if (parts.length >= 2) {
        }
        if (parts.length >= 3) {
        }
      });
      
    };
    
    // Function to setup alt text for images (helper for theme editor)
    window.setupImageAltText = function() {
      const sizes = Array.from(sizeOptions).map(opt => opt.dataset.size);
      const colors = Array.from(colorCircles).map(circle => circle.dataset.color);
      const locks = Array.from(lockOptions).map(opt => opt.dataset.lock);
      
      
      // Generate examples for complete variants
      if (sizes.length > 0 && colors.length > 0 && locks.length > 0) {
        if (sizes[1] && colors[1] && locks[1]) {
        }
      }
    };
    
    // ============================================
    // TEST DYNAMIC OPTION DETECTION
    // ============================================
    window.testDynamicOptions = function() {
      
      // 1. Check option map
      
      // 2. Analyze product structure
      productData.options.forEach((opt, idx) => {
      });
      
      // 3. Show available selectors
      
      // 4. Sample variants
      productData.variants.slice(0, 3).forEach((v, idx) => {
      });
      
      // 5. Test variant matching
      if (sizeOptions.length > 0 && sizeOptions[0]) {
        const testSize = sizeOptions[0].dataset.size;
        sizeOptions[0].click();
        
        setTimeout(() => {
          const matched = findMatchingVariant();
        }, 500);
      }
    };
    
    // Helper: Quick option detection checker
    window.checkProductOptions = function() {
    };
    
    // Re-initialize tooltips to ensure all elements have tooltips (after a short delay for dynamic content)
    setTimeout(() => {
      initTooltips();
    }, 500);
    
    // Wait a bit for size options to be ready
    setTimeout(function() {
      initializeModalSystem();
    }, 1000);
    
    // Add global debug function for testing size option clicks
    window.debugSizeOptions = function() {
      const sizeOptions = document.querySelectorAll('.size-option');
      
      sizeOptions.forEach((option, index) => {
        const computedStyle = window.getComputedStyle(option);
        
        // Test if click works by adding a temporary listener
        const testClick = function() {
          option.removeEventListener('click', testClick);
        };
        option.addEventListener('click', testClick);
      });
      
    };
    
    // Auto-run the debug after elements are ready
    setTimeout(() => {
      window.debugSizeOptions();
    }, 2000);
  }
  
  function initializeModalSystem() {
    // Create modal elements
    let zoomBackdrop = document.querySelector('.zoom-backdrop');
    let zoomModal = document.querySelector('.size-image-zoom');
    
    if (!zoomBackdrop) {
      zoomBackdrop = document.createElement('div');
      zoomBackdrop.className = 'zoom-backdrop';
      document.body.appendChild(zoomBackdrop);
    }
    
    if (!zoomModal) {
      zoomModal = document.createElement('div');
      zoomModal.className = 'size-image-zoom';
      zoomModal.innerHTML = `
        <button class="close-button" type="button">✕</button>
        <img src="" alt="">
        <div class="zoom-label"></div>
      `;
      document.body.appendChild(zoomModal);
    }
  
    const zoomImg = zoomModal.querySelector('img');
    const zoomLabel = zoomModal.querySelector('.zoom-label');
    const closeButton = zoomModal.querySelector('.close-button');
  
    // Find all size options
    const sizeOptions = document.querySelectorAll('.size-option');
  
    sizeOptions.forEach((option, index) => {
      
      // Remove existing expand icon
      const existingIcon = option.querySelector('.expand-icon');
      if (existingIcon) {
        existingIcon.remove();
      }
  
      // Create expand icon
      const expandIcon = document.createElement('div');
      expandIcon.className = 'expand-icon';
      expandIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m15 15 6 6"/>
          <path d="m15 9 6-6"/>
          <path d="M21 16v5h-5"/>
          <path d="M21 8V3h-5"/>
          <path d="M3 16v5h5"/>
          <path d="m3 21 6-6"/>
          <path d="M3 8V3h5"/>
          <path d="M9 9 3 3"/>
        </svg>
      `;
      
      option.appendChild(expandIcon);
  
      // Add click handler with mobile-friendly logic
      expandIcon.addEventListener('click', function(e) {
        // Always stop propagation to prevent the size option from being clicked when clicking the expand icon
        e.stopPropagation();
        
        // Check if we're on a mobile device
        const isMobile = isMobileDevice();
        
        if (isMobile) {
          // On mobile, show the modal but prevent default to avoid any unwanted behavior
          e.preventDefault();
        } else {
          // Desktop behavior - prevent default for modal
          e.preventDefault();
        }
        
        const image = option.querySelector('.size-image');
        
        if (image && image.src) {
          const label = option.getAttribute('data-label') || 
                       option.getAttribute('data-size') || 
                       option.querySelector('.size-label')?.textContent || 
                       'Size Image';
          const zoomSrc = image.dataset.zoomSrc || image.currentSrc || image.src;
          
          // Set modal content
          zoomImg.src = zoomSrc;
          zoomImg.alt = label;
          zoomLabel.textContent = label;
          
          // Show modal
          zoomBackdrop.classList.add('visible');
          zoomModal.classList.add('visible');
          document.body.style.overflow = 'hidden';
          
        } else {
        }
      });
  
      // Also add a test click handler to the entire option for debugging
      option.addEventListener('click', function(e) {
      });
    });
  
    // Close modal handlers
    closeButton.addEventListener('click', function() {
      closeModal();
    });
  
    zoomBackdrop.addEventListener('click', function(e) {
      if (e.target === zoomBackdrop) {
        closeModal();
      }
    });
  
    function closeModal() {
      zoomBackdrop.classList.remove('visible');
      zoomModal.classList.remove('visible');
      document.body.style.overflow = '';
    }
  
  }
  
  // Add global debug function
  window.testModal = function() {
    const sizeOptions = document.querySelectorAll('.size-option');
    const expandIcons = document.querySelectorAll('.expand-icon');
    
    
    sizeOptions.forEach((option, index) => {
      const image = option.querySelector('.size-image');
      const expandIcon = option.querySelector('.expand-icon');
    });
    
    // Try to manually trigger the first expand icon
    const firstIcon = document.querySelector('.expand-icon');
    if (firstIcon) {
      firstIcon.click();
    } else {
    }
  };
  


  
  // Test function to manually trigger updateProductImage
  window.testGalleryUpdate = function(variantId) {
    
    const productJsonElement = document.getElementById('product-json');
    if (!productJsonElement) {
      return;
    }
    
    try {
      const productData = JSON.parse(productJsonElement.textContent);
      const variant = productData.variants.find(v => v.id == variantId) || productData.variants[0];
      
      if (variant && variant.featured_image) {
        
        // Call the updateProductImage function directly
        const newImageUrl = variant.featured_image.src;
        const newImageAlt = variant.featured_image.alt || variant.name || productData.title;
        const cleanImageUrl = newImageUrl.includes('?') ? newImageUrl.split('?')[0] : newImageUrl;
        
        // Find and update the main image
        const firstGalleryImage = document.querySelector('.product-gallery__main .product-gallery__image:first-child img');
        if (firstGalleryImage) {
          const mainImageUrl = cleanImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_1200x.$1');
          firstGalleryImage.src = mainImageUrl + '?v=' + Date.now();
          firstGalleryImage.alt = newImageAlt;
        } else {
        }
        
        // Update thumbnail
        const firstThumbnail = document.querySelector('.product-gallery__thumbnails .product-gallery__thumbnail:first-child img');
        if (firstThumbnail) {
          const thumbUrl = cleanImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_300x.$1');
          firstThumbnail.src = thumbUrl + '?v=' + Date.now();
          firstThumbnail.alt = newImageAlt;
        } else {
        }
      } else {
      }
    } catch (e) {
    }
  };
  
  // Debug functions for testing gallery integration
  window.testGalleryIntegration = function() {
    
    // Check if required elements exist
    const galleryMain = document.querySelector('.product-gallery__main');
    const variantScript = document.getElementById('variant-images-' + (productData ? productData.id : 'unknown'));
    const sectionScript = document.querySelector('[data-section-data]');
    
    
    if (productData) {
      // Test with first variant
      const firstVariant = productData.variants[0];
      if (firstVariant) {
        
        // Test Shopify's method directly
        updateMainGalleryImageShopifyWay(firstVariant);
      }
    } else {
    }
    
  };
  
  window.testVariantSelection = function(size, color, lock) {
    
    // Update selections
    if (size) selectedSize = size;
    if (color) selectedColor = color; 
    if (lock) selectedLock = lock;
    
    // Trigger update
    updateSelectedVariant();
    
    // Show what variant was found
    const variant = findMatchingVariant();
    if (variant) {
    } else {
    }
  };
  
    // Function to add main product + upgrades to cart as separate line items
    async function addToCartWithUpgrades() {
      const variant = findMatchingVariant();
      if (!variant) {
        alert('Please select all options');
        return;
      }
      
      // Disable the button during processing
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding to Cart...';
      
      try {
        const cartItems = [];
        
        // 1. Main product item
        const mainItem = {
          id: variant.id,
          quantity: 1,
          properties: {
            'Selected Size': selectedSize || '',
            'Selected Color': selectedColor || '',
            'Selected Lock': selectedLock || '',
            'Selected Upgrade': selectedUpgrade || ''
            // Removed Total Price property - pricing should come from variant
          }
        };
        cartItems.push(mainItem);
        
        // 2. Create hidden upgrade items if needed
        if (selectedLock && selectedLock !== 'No Lock Upgrade') {
          const lockCost = extractPriceFromOption(selectedLock);
          if (lockCost > 0) {
            // You'll need to create a hidden product for lock upgrades in Shopify admin
            // For now, we'll add it as a line item property and adjust the main item price
          }
        }
        
        if (selectedUpgrade && selectedUpgrade !== 'No Upgrade') {
          const upgradeCost = extractUpgradeCost(selectedUpgrade);
          if (upgradeCost > 0) {
            // You'll need to create a hidden product for upgrades in Shopify admin
            // For now, we'll add it as a line item property and adjust the main item price
          }
        }
        
        if (selectedDelivery > 0) {
          // Delivery functionality is commented out
        }
        
        // Add items to cart using AJAX
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: cartItems
          })
        });
        
        if (response.ok) {
          
          // Update cart count and redirect to cart or show success message
          updateCartCount();
          
          // Redirect to cart page or show success message
          if (window.location.pathname !== '/cart') {
            window.location.href = '/cart';
          } else {
            // If already on cart page, reload it
            window.location.reload();
          }
        } else {
          throw new Error('Failed to add to cart');
        }
        
      } catch (error) {
        alert('Error adding to cart. Please try again.');
      } finally {
        // Re-enable the button
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart - ' + formatMoney(calculateTotalPrice(variant));
      }
    }
    
    // Helper function to update cart count in header
    function updateCartCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Update cart count in header (adjust selector as needed)
          const cartCountElements = document.querySelectorAll('.cart-count, .cart__item-count, [data-cart-count]');
          cartCountElements.forEach(element => {
            element.textContent = cart.item_count;
          });
        })
        .catch(error => {
        });
    }


// Re-initialize when Shopify theme editor loads or reorders this section
function safeBuilderInit() {
  window.pageLoadTime = Date.now();
  initTooltips();
  initStickyCart();
  setTimeout(initializeCustomVariantSelection, 500);
  // Re-initialize gallery after section reload
  if (window.SBGallery) {
    document.querySelectorAll('.sb-gallery').forEach(function(g) {
      g._sbInitialized = false;
    });
  }
}

document.addEventListener('shopify:section:load', function(e) {
  if (e.target.querySelector('.product-builder-section')) {
    safeBuilderInit();
  }
});

document.addEventListener('shopify:section:select', function(e) {
  if (e.target.querySelector('.product-builder-section')) {
    if (typeof lucide !== 'undefined') lucide.createIcons();
  }
});
